{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDataGridCell;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$DEFINE FMXWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE FMXWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.Controls, WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCTypes, WEBLib.TMSFNCDataGridCore, WEBLib.Graphics,
  WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCButton, WEBLib.TMSFNCBitmapContainer, WEBLib.StdCtrls, WEBLib.TMSFNCGraphics, SysUtils, Rtti
  {$IFDEF FMXLIB}
  ,FMX.Types
  {$ENDIF}
  ,Generics.Collections, Generics.Defaults, Types
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,VCL.ComCtrls
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.ComCtrls, WEB
  {$ENDIF}
  ;

type
  TTMSFNCDataGridCellState = (gcsNormal, gcsFocused, gcsFixed, gcsFixedSelected, gcsSelected);

  TTMSFNCDataGridCellLayout = class(TPersistent)
  private
    FFill: TTMSFNCGraphicsFill;
    FFont: TTMSFNCGraphicsFont;
    FOnChange: TNotifyEvent;
    FStroke: TTMSFNCGraphicsStroke;
    FTextAlign: TTMSFNCGraphicsTextAlign;
    FTextAngle: Double;
    FVerticalTextAlign: TTMSFNCGraphicsTextAlign;
    FWordWrapping: Boolean;
    FSides: TTMSFNCGraphicsSides;
    function IsTextAngleStored: Boolean;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetFont(const Value: TTMSFNCGraphicsFont);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetTextAngle(const Value: Double);
    procedure SetVerticalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetWordWrapping(const Value: Boolean);
    procedure SetSides(const Value: TTMSFNCGraphicsSides);
  protected
    procedure Changed;
    procedure FillChanged(Sender: TObject);
    procedure FontChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
  public
    constructor Create(ADefaultFillColor: TTMSFNCGraphicsColor = gcWhite); virtual;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property Sides: TTMSFNCGraphicsSides read FSides write SetSides default [gsLeft, gsTop, gsRight, gsBottom];
    property Font: TTMSFNCGraphicsFont read FFont write SetFont;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property TextAlign: TTMSFNCGraphicsTextAlign read FTextAlign write SetTextAlign default gtaLeading;
    property TextAngle: Double read FTextAngle write SetTextAngle stored IsTextAngleStored nodefault;
    property VerticalTextAlign: TTMSFNCGraphicsTextAlign read FVerticalTextAlign write SetVerticalTextAlign default gtaCenter;
    property WordWrapping: Boolean read FWordWrapping write SetWordWrapping default False;
  end;

  TTMSFNCDataGridCellKind = (gckCell, gckFixedRootCell, gckFixedRowCell, gckFixedColumnCell, gckFreezeRootCell,
    gckFreezeRowCell, gckFreezeColumnCell, gckFreezeFixedRowCell, gckFreezeFixedColumnCell);

  {$IFNDEF WEBLIB}
  TTMSFNCDataGridCellValue = TValue;
  {$ELSE}
  TTMSFNCDataGridCellValue = JSValue;
  {$ENDIF}

  TTMSFNCDataGridCellItem = class;

  TTMSFNCDataGridRows = class(TObjectDictionary<Integer, TTMSFNCDataGridCellItem>);

  TTMSFNCDataGridRowItem = class(TPersistent)
  private
    FData: TTMSFNCDataGridRows;
    FNodeLevel: Integer;
    FNodeChildCount: Integer;
    FNodeState: TTMSFNCDataGridRowNodeState;
    FType: TTMSFNCDataGridRowType;
    function GetData: TTMSFNCDataGridRows;
  public
    destructor Destroy; override;
    procedure Assign(Source: TTMSFNCDataGridRowItem; AHost: TObject); reintroduce; virtual;
    procedure Init;
    function HasData: Boolean;
    property Data: TTMSFNCDataGridRows read GetData;
  published
    property &Type: TTMSFNCDataGridRowType read FType write FType;
    property NodeChildCount: Integer read FNodeChildCount write FNodeChildCount;
    property NodeLevel: Integer read FNodeLevel write FNodeLevel;
    property NodeState: TTMSFNCDataGridRowNodeState read FNodeState write FNodeState;
  end;

  TTMSFNCDataGridCellMergeInfo = record
    ColumnOffset, RowOffset, ColumnSpan, RowSpan: Integer;
  end;

  {$IFDEF FMXLIB}
  TTMSFNCDataGridCellControl = TControl;
  TTMSFNCDataGridCellParent = TFmxObject;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCDataGridCellControl = TWinControl;
  TTMSFNCDataGridCellParent = TWinControl;
  {$ENDIF}

  TTMSFNCDataGridCellItemType = (gcitNormal, gcitCheckBox, gcitRadioButton, gcitDataCheckBox, gcitDataRadioButton, gcitButton, gcitProgressBar, gcitDataProgressBar, gcitBitmap);

  TTMSFNCDataGridCellItemTypeRange = (gcirNormal, gcirFixed, gcirAll);

  TTMSFNCDataGridCellItemExtended = class;

  {$IFDEF WEBLIB}
  TTMSFNCDataGridCellItemVariant = JSValue;
  {$ELSE}
  TTMSFNCDataGridCellItemVariant = Variant;
  {$ENDIF}

  TTMSFNCDataGridCellItem = class(TPersistent)
  private
    FHost: TObject;
    FDisplayValue: string;
    FValue: TTMSFNCDataGridCellValue;
    FInvalid: Boolean;
    procedure SetValue(const V: TTMSFNCDataGridCellValue);
  public
    constructor Create(AHost: TObject = nil); virtual;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    property Invalid: Boolean read FInvalid write FInvalid;
    property DisplayValue: string read FDisplayValue write FDisplayValue;
    property Value: TTMSFNCDataGridCellValue read FValue write SetValue;
  end;

  TTMSFNCDataGridCellControlAlign = (gcaNone, gcaLeft, gcaTop, gcaRight, gcaBottom, gcaClient);
  TTMSFNCDataGridCellControlPosition = (gcpTopLeft, gcpTopCenter, gcpTopRight, gcpCenterLeft, gcpCenterCenter, gcpCenterRight,
    gcpBottomLeft, gcpBottomCenter, gcpBottomRight);

  TTMSFNCDataGridCellItemExtended = class(TTMSFNCDataGridCellItem)
  private
    FObject: TObject;
    FMergeInfo: TTMSFNCDataGridCellMergeInfo;
    FManagedObject: TObject;
    FControl: TTMSFNCDataGridCellControl;
    FReadOnly: Boolean;
    FBooleanValue: Boolean;
    FType: TTMSFNCDataGridCellItemType;
    FIntegerValue: Integer;
    FBitmapName: string;
    FBitmap: TTMSFNCBitmap;
    FComment: string;
    FRadioGroupIndex: Integer;
    FDataPointer: Pointer;
    FDataBoolean: Boolean;
    FDataString: String;
    FDataObject: TObject;
    FDataInteger: NativeInt;
    FControlMargins: TTMSFNCMargins;
    FLayout: TTMSFNCDataGridCellLayout;
    FRenderer: TObject;
    FControlText: string;
    FControlHeight: Integer;
    FControlAlign: TTMSFNCDataGridCellControlAlign;
    FControlWidth: Integer;
    FControlPosition: TTMSFNCDataGridCellControlPosition;
    FHint: string;
    FFilterEditor: TTMSFNCDataGridCellControl;
    function GetBitmap: TTMSFNCBitmap;
    function GetColumnOffset: Integer;
    function GetColumnSpan: Integer;
    function GetRowOffset: Integer;
    function GetRowSpan: Integer;
    procedure SetColumnOffset(const Value: Integer);
    procedure SetColumnSpan(const Value: Integer);
    procedure SetRowOffset(const Value: Integer);
    procedure SetRowSpan(const Value: Integer);
    function GetControlMargins: TTMSFNCMargins;
  protected
    property Renderer: TObject read FRenderer write FRenderer;
    property Layout: TTMSFNCDataGridCellLayout read FLayout write FLayout;
    property FilterEditor: TTMSFNCDataGridCellControl read FFilterEditor write FFilterEditor;
    procedure DestroyFilterEditor;
    procedure DestroyLayout;
    procedure DestroyRenderer;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AHost: TObject = nil); override;
    destructor Destroy; override;
    function HasMergeInfo: Boolean;

    property DataPointer: Pointer read FDataPointer write FDataPointer;
    property DataBoolean: Boolean read FDataBoolean write FDataBoolean;
    property DataObject: TObject read FDataObject write FDataObject;
    property DataString: String read FDataString write FDataString;
    property DataInteger: NativeInt read FDataInteger write FDataInteger;
    property &Object: TObject read FObject write FObject;
    property ManagedObject: TObject read FManagedObject write FManagedObject;
    property Control: TTMSFNCDataGridCellControl read FControl write FControl;
    property MergeInfo: TTMSFNCDataGridCellMergeInfo read FMergeInfo write FMergeInfo;
  published
    property ColumnOffset: Integer read GetColumnOffset write SetColumnOffset;
    property RowOffset: Integer read GetRowOffset write SetRowOffset;
    property ColumnSpan: Integer read GetColumnSpan write SetColumnSpan;
    property RowSpan: Integer read GetRowSpan write SetRowSpan;
    property IntegerValue: Integer read FIntegerValue write FIntegerValue;
    property BooleanValue: Boolean read FBooleanValue write FBooleanValue;
    property ControlMargins: TTMSFNCMargins read GetControlMargins;
    property ControlAlign: TTMSFNCDataGridCellControlAlign read FControlAlign write FControlAlign default gcaNone;
    property ControlPosition: TTMSFNCDataGridCellControlPosition read FControlPosition write FControlPosition default gcpCenterRight;
    property ControlText: string read FControlText write FControlText;
    property ControlWidth: Integer read FControlWidth write FControlWidth default -1;
    property ControlHeight: Integer read FControlHeight write FControlHeight default -1;
    property ReadOnly: Boolean read FReadOnly write FReadOnly default False;
    property &Type: TTMSFNCDataGridCellItemType read FType write FType default gcitNormal;
    property Comment: string read FComment write FComment;
    property Hint: string read FHint write FHint;
    property Bitmap: TTMSFNCBitmap read GetBitmap;
    property BitmapName: string read FBitmapName write FBitmapName;
    property RadioGroupIndex: Integer read FRadioGroupIndex write FRadioGroupIndex default 0;
  end;

  TTMSFNCDataGridKeyKind = (gkkNone, gkkDown, gkkUp, gkkDialog, gkkPress);

  TTMSFNCDataGridKeyInfo = record
    Key: Word;
    KeyChar: Char;
    Blocked: Boolean;
    Shift: TShiftState;
    Kind: TTMSFNCDataGridKeyKind;
    Handled: Boolean;
  end;

  TTMSFNCDataGridMouseKind = (gmkNone, gmkDown, gmkMove, gmkUp, gmkWheel, gmkEnter, gmkLeave, gmkDouble);

  TTMSFNCDataGridMouseInfo = record
    Button: TMouseButton;
    X, Y: Single;
    Shift: TShiftState;
    Kind: TTMSFNCDataGridMouseKind;
    WheelDelta: Integer;
    Blocked: Boolean;
    Handled: Boolean;
    Cursor: TCursor;
  end;

  TTMSFNCDataGridCellDrawElement = (gcdFill, gcdStroke, gcdText, gcdControl, gcdNodeIcon, gcdSortIndicator, gcdFilterButton, gcdCommentIndicator);
  TTMSFNCDataGridCellDrawElements = set of TTMSFNCDataGridCellDrawElement;

  TTMSFNCDataGridCellSortIndicator = (gsiNone, gsiAscending, gsiDescending);

  TTMSFNCDataGridCellControlWrapper = class({$IFDEF FMXLIB}TControl{$ELSE}TCustomControl{$ENDIF})
  protected
  {$IFDEF FMXWEBLIB}
    function EnterChildren(AObject: IControl): Boolean; override;
    function ExitChildren(AObject: IControl): Boolean; override;
  {$ENDIF}
  {$IFDEF VCLLIB}
    procedure Paint; override;
  {$ENDIF}
  {$IFDEF WEBLIB}
    function CreateElement: TJSElement; override;
  {$ENDIF}
  end;

  TTMSFNCDataGridCellControlInfo = class
  private
    FWidth: Single;
    FHeight: Single;
    FType: TClass;
    FText: string;
    FFocused: Boolean;
    FCaption: string;
    FTag: Integer;
  public
    function CopyInstance: TTMSFNCDataGridCellControlInfo; virtual;
    procedure Assign(Source: TTMSFNCDataGridCellControlInfo); virtual;
    constructor Create; virtual;
    function Compare(AInfo: TTMSFNCDataGridCellControlInfo): Boolean; virtual;
    property &Type: TClass read FType write FType;
    property Width: Single read FWidth write FWidth;
    property Height: Single read FHeight write FHeight;
    property Text: string read FText write FText;
    property Caption: string read FCaption write FCaption;
    property Focused: Boolean read FFocused write FFocused;
    property Tag: Integer read FTag write FTag;
  end;

  TTMSFNCDataGridCellControlInfoClass = class of TTMSFNCDataGridCellControlInfo;

  TTMSFNCDataGridCellControlCache = class
  private
    FInfo: TTMSFNCDataGridCellControlInfo;
    FBitmap: TTMSFNCBitmap;
    function GetBitmap: TTMSFNCBitmap;
  public
    constructor Create(AInfo: TTMSFNCDataGridCellControlInfo; ABitmap: TTMSFNCBitmap); virtual;
    destructor Destroy; override;
    property Bitmap: TTMSFNCBitmap read GetBitmap;
    property Info: TTMSFNCDataGridCellControlInfo read FInfo;
  end;

  TTMSFNCDataGridCellControlCacheList = class(TObjectList<TTMSFNCDataGridCellControlCache>)
  public
    function GetCacheItem(AControlCacheInfo: TTMSFNCDataGridCellControlInfo): TTMSFNCDataGridCellControlCache;
    procedure RemoveItem(AControlCacheInfo: TTMSFNCDataGridCellControlInfo);
  end;

const
  AllElements = [gcdFill, gcdStroke, gcdText, gcdControl, gcdNodeIcon, gcdSortIndicator, gcdFilterButton, gcdCommentIndicator];
  EditingElements = [gcdControl, gcdSortIndicator, gcdNodeIcon, gcdFilterButton, gcdCommentIndicator];
  ExportElements = [gcdFill, gcdStroke, gcdText, gcdControl];

type
  TTMSFNCDataGridCellBeforeDrawEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics; var ACanDraw: Boolean) of object;
  TTMSFNCDataGridCellAfterDrawEvent = procedure(Sender: TObject; AGraphics: TTMSFNCGraphics) of object;

  TTMSFNCDataGridCell = class
  private
    class var FControlCacheList: TTMSFNCDataGridCellControlCacheList;
  private
    FControl: TTMSFNCDataGridCellControl;
    FScale: Single;
    FControlActive: Boolean;
    FControlCache: TTMSFNCBitmap;
    FControlWrapper: TTMSFNCDataGridCellControlWrapper;
    FRect: TRectF;
    FKind: TTMSFNCDataGridCellKind;
    FRow: Integer;
    FColumn: Integer;
    FData: TTMSFNCDataGridCellItem;
    FLayout: TTMSFNCDataGridCellLayout;
    FIsExporting: Boolean;
    FCalcRect: TRectF;
    FControlRef: TTMSFNCDataGridCellControl;
    FControlAlign: TTMSFNCDataGridCellControlAlign;
    FDrawElements: TTMSFNCDataGridCellDrawElements;
    FSortIndicator: TTMSFNCDataGridCellSortIndicator;
    FFilterButton: Boolean;
    FCommentIndicator: Boolean;
    FDownOnFilterButton, FDownOnComment: Boolean;
    FOnCommentIndicatorClick: TNotifyEvent;
    FOnFilterButtonClick: TNotifyEvent;
    FBitmapContainer: TTMSFNCBitmapContainer;
    FComment: string;
    FClipRect: TRectF;
    FRoot: TObject;
    FControlInfo: TTMSFNCDataGridCellControlInfo;
    FCommentIndicatorColor: TTMSFNCGraphicsColor;
    FControlPosition: TTMSFNCDataGridCellControlPosition;
    FFilterIcon: TTMSFNCBitmap;
    FControlMargins: TTMSFNCMargins;
    FSortDescendingIcon: TTMSFNCBitmap;
    FSortAscendingIcon: TTMSFNCBitmap;
    FOnAfterDraw: TTMSFNCDataGridCellAfterDrawEvent;
    FOnBeforeDraw: TTMSFNCDataGridCellBeforeDrawEvent;
    function GetLayout: TTMSFNCDataGridCellLayout;
    function GetCoordinate: TTMSFNCDataGridCellCoord;
    function GetHeight: Single;
    function GetLeft: Single;
    function GetTop: Single;
    function GetWidth: Single;
    function GetBottom: Single;
    function GetRight: Single;
    function GetText: string;
    function GetControlWrapper: TTMSFNCDataGridCellControlWrapper;
    function GetControlInfo: TTMSFNCDataGridCellControlInfo; virtual;
    function GetScale: Single;
    function GetControlMargins: TTMSFNCMargins;
    procedure SetControlMargins(const Value: TTMSFNCMargins);
  protected
    function GetControlBitmap: TTMSFNCBitmap; virtual;
    function GetControl: TTMSFNCDataGridCellControl; virtual;
    function GetDisplayValue: string; virtual;
    function GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF; virtual;
    function GetSortIndicatorSize: Single; virtual;
    function GetFilterButtonSize: Single; virtual;
    function GetCommentIndicatorSize: Single; virtual;
    function GetTextRect: TRectF; virtual;
    function GetControlRect(AApplySize: Boolean): TRectF; virtual;
    function GetSortIndicatorRect: TRectF; virtual;
    function GetControlWidth: Single; virtual;
    function GetControlHeight: Single; virtual;
    function GetFilterButtonRect: TRectF; virtual;
    function GetCommentIndicatorRect: TRectF; virtual;
    function GetActualTextRect: TRectF; virtual;
    function GetTextSize(AGraphics: TTMSFNCGraphics = nil): TSizeF; virtual;
    function IsControlAssigned: Boolean; virtual;
    function SupportsRealControl: Boolean; virtual;
    function GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass; virtual;
    function CreateControlCache: TTMSFNCBitmap; virtual;
    function CreateControl: TTMSFNCDataGridCellControl; virtual;
    function GetDrawElements(AIsEditing: Boolean): TTMSFNCDataGridCellDrawElements; virtual;

    procedure DoControlWrapperEnter(Sender: TObject);
    procedure DoControlWrapperExit(Sender: TObject);
    procedure DoBeforeDraw(AGraphics: TTMSFNCGraphics; var ACanDraw: Boolean); virtual;
    procedure DoAfterDraw(AGraphics: TTMSFNCGraphics); virtual;
    procedure UpdateData(AData: TTMSFNCDataGridCellItem); virtual;
    procedure InitializeControl; virtual;
    procedure RetrieveControlInfo(AInfo: TTMSFNCDataGridCellControlInfo); virtual;
    procedure ApplyScale(AScale: Single); virtual;
    procedure DoFilterButtonClick;
    procedure DoCommentIndicatorClick;
    procedure ApplyControlColor; virtual;
    procedure ApplyControlProperties; virtual;
    property OnFilterButtonClick: TNotifyEvent read FOnFilterButtonClick write FOnFilterButtonClick;
    property OnCommentIndicatorClick: TNotifyEvent read FOnCommentIndicatorClick write FOnCommentIndicatorClick;
    property OnBeforeDraw: TTMSFNCDataGridCellBeforeDrawEvent read FOnBeforeDraw write FOnBeforeDraw;
    property OnAfterDraw: TTMSFNCDataGridCellAfterDrawEvent read FOnAfterDraw write FOnAfterDraw;
    property ControlWrapper: TTMSFNCDataGridCellControlWrapper read GetControlWrapper;
    property CalcRect: TRectF read FCalcRect write FCalcRect;
    property Root: TObject read FRoot write FRoot;
    property ControlInfo: TTMSFNCDataGridCellControlInfo read GetControlInfo;
    property SortAscendingIcon: TTMSFNCBitmap read FSortAscendingIcon write FSortAscendingIcon;
    property SortDescendingIcon: TTMSFNCBitmap read FSortDescendingIcon write FSortDescendingIcon;
    property FilterIcon: TTMSFNCBitmap read FFilterIcon write FFilterIcon;
    class property ControlCacheList: TTMSFNCDataGridCellControlCacheList read FControlCacheList;
  public
    constructor Create(ARect: TRectF; AColumn, ARow: Integer; AData: TTMSFNCDataGridCellItem; AKind: TTMSFNCDataGridCellKind; ARoot: TObject); virtual;
    destructor Destroy; override;
    function IsHTML: Boolean;
    function XYToAnchor(X, Y: Single): string;
    procedure BeforeExport; virtual;
    procedure AfterExport; virtual;
    procedure Draw(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawBackground(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawContent(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawControl(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawSortIndicator(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawFilterButton(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawCommentIndicator(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawText(AGraphics: TTMSFNCGraphics); virtual;
    procedure HandleMouse(var AMouseInfo: TTMSFNCDataGridMouseInfo); virtual;
    procedure HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo); virtual;
    procedure ClearControlCache; virtual;
    property Scale: Single read GetScale;
    property IsExporting: Boolean read FIsExporting;
    property Column: Integer read FColumn;
    property Coordinate: TTMSFNCDataGridCellCoord read GetCoordinate;
    property Data: TTMSFNCDataGridCellItem read FData;
    property Kind: TTMSFNCDataGridCellKind read FKind;
    property Layout: TTMSFNCDataGridCellLayout read GetLayout;
    property Rect: TRectF read FRect write FRect;
    property ClipRect: TRectF read FClipRect write FClipRect;
    property Row: Integer read FRow;
    property Top: Single read GetTop;
    property Left: Single read GetLeft;
    property Right: Single read GetRight;
    property Bottom: Single read GetBottom;
    property Height: Single read GetHeight;
    property Width: Single read GetWidth;
    property Text: string read GetText;
    property TextRect: TRectF read GetTextRect;
    property DrawElements: TTMSFNCDataGridCellDrawElements read FDrawElements write FDrawElements default AllElements;
    property ControlMargins: TTMSFNCMargins read GetControlMargins write SetControlMargins;
    property ControlAlign: TTMSFNCDataGridCellControlAlign read FControlAlign write FControlAlign default gcaNone;
    property ControlPosition: TTMSFNCDataGridCellControlPosition read FControlPosition write FControlPosition default gcpCenterRight;
    property Control: TTMSFNCDataGridCellControl read GetControl write FControl;
    property SortIndicator: TTMSFNCDataGridCellSortIndicator read FSortIndicator write FSortIndicator default gsiNone;
    property FilterButton: Boolean read FFilterButton write FFilterButton default False;
    property Comment: string read FComment write FComment;
    property CommentIndicator: Boolean read FCommentIndicator write FCommentIndicator default False;
    property CommentIndicatorColor: TTMSFNCGraphicsColor read FCommentIndicatorColor write FCommentIndicatorColor default gcOrange;
    property BitmapContainer: TTMSFNCBitmapContainer read FBitmapContainer write FBitmapContainer;
  end;

  TTMSFNCDataGridNodeCellIconPosition = (gcipTop, gcipCenter, gcipBottom);

  TTMSFNCDataGridNodeCell = class(TTMSFNCDataGridCell)
  private
    FState: TTMSFNCDataGridRowNodeState;
    FDownOnNode: Boolean;
    FOnCollapse: TNotifyEvent;
    FOnExpand: TNotifyEvent;
    FIconPosition: TTMSFNCDataGridNodeCellIconPosition;
    FIconSize: Single;
    FCollapseIcon: TTMSFNCBitmap;
    FExpandIcon: TTMSFNCBitmap;
  protected
    function GetTextRect: TRectF; override;
    function GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF; override;
    function GetNodeSize: Single; virtual;
    function GetNodeRect: TRectF; virtual;
    procedure DoExpand;
    procedure DoCollapse;
    property CollapseIcon: TTMSFNCBitmap read FCollapseIcon write FCollapseIcon;
    property ExpandIcon: TTMSFNCBitmap read FExpandIcon write FExpandIcon;
  public
    constructor Create(ARect: TRectF; AColumn, ARow: Integer; AData: TTMSFNCDataGridCellItem; AKind: TTMSFNCDataGridCellKind; ARoot: TObject); override;
    destructor Destroy; override;
    procedure HandleMouse(var AMouseInfo: TTMSFNCDataGridMouseInfo); override;
    procedure DrawContent(AGraphics: TTMSFNCGraphics); override;
    property State: TTMSFNCDataGridRowNodeState read FState write FState;
    property IconPosition: TTMSFNCDataGridNodeCellIconPosition read FIconPosition write FIconPosition default gcipCenter;
    property IconSize: Single read FIconSize write FIconSize;
    property OnCollapse: TNotifyEvent read FOnCollapse write FOnCollapse;
    property OnExpand: TNotifyEvent read FOnExpand write FOnExpand;
  end;

  TTMSFNCDataGridCheckedCellControlInfo = class(TTMSFNCDataGridCellControlInfo)
  private
    FChecked: Boolean;
  public
    function CopyInstance: TTMSFNCDataGridCellControlInfo; override;
    procedure Assign(Source: TTMSFNCDataGridCellControlInfo); override;
    constructor Create; override;
    function Compare(AInfo: TTMSFNCDataGridCellControlInfo): Boolean; override;
    property Checked: Boolean read FChecked write FChecked;
  end;

  TTMSFNCDataGridCheckedCell = class(TTMSFNCDataGridCell)
  private
    FChecked: Boolean;
    FOnChange: TNotifyEvent;
  protected
    function GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass; override;
    function SupportsRealControl: Boolean; override;
    procedure RetrieveControlInfo(AInfo: TTMSFNCDataGridCellControlInfo); override;
  public
    property Checked: Boolean read FChecked write FChecked;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  end;

  TTMSFNCDataGridCheckBox = class(TCheckBox)
  {$IFDEF WEBLIB}
  protected
    procedure UpdateElementVisual; override;
  public
    function MakeScreenshot: TBitmap; override;
  {$ENDIF}
  end;

  TTMSFNCDataGridCheckBoxCell = class(TTMSFNCDataGridCheckedCell)
  private
    function GetCheckBox: TTMSFNCDataGridCheckBox;
  protected
    procedure DoCheckChange(Sender: TObject);
    procedure ApplyControlProperties; override;
    procedure InitializeControl; override;
    function CreateControl: TTMSFNCDataGridCellControl; override;
  public
    procedure HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo); override;
    property CheckBox: TTMSFNCDataGridCheckBox read GetCheckBox;
  end;

  TTMSFNCDataGridDataCheckBoxCell = class(TTMSFNCDataGridCheckBoxCell);

  TTMSFNCDataGridRadioButton = class(TRadioButton)
  {$IFDEF WEBLIB}
  protected
    procedure UpdateElementVisual; override;
  public
    function MakeScreenshot: TBitmap; override;
  {$ENDIF}
  end;

  TTMSFNCDataGridRadioButtonCell = class(TTMSFNCDataGridCheckedCell)
  private
    function GetRadioButton: TTMSFNCDataGridRadioButton;
  protected
    procedure DoRadioChange(Sender: TObject);
    procedure ApplyControlProperties; override;
    procedure InitializeControl; override;
    function CreateControl: TTMSFNCDataGridCellControl; override;
  public
    procedure HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo); override;
    property RadioButton: TTMSFNCDataGridRadioButton read GetRadioButton;
  end;

  TTMSFNCDataGridDataRadioButtonCell = class(TTMSFNCDataGridRadioButtonCell);

  TTMSFNCDataGridButtonCell = class(TTMSFNCDataGridCell)
  private
    FOnClick: TNotifyEvent;
    function GetButton: TButton;
  protected
    function SupportsRealControl: Boolean; override;
    function CreateControl: TTMSFNCDataGridCellControl; override;
    procedure InitializeControl; override;
    procedure DoButtonClick(Sender: TObject);
  public
    property OnClick: TNotifyEvent read FOnClick write FOnClick;
    property Button: TButton read GetButton;
  end;

  TTMSFNCDataGridFNCButtonCell = class(TTMSFNCDataGridCell)
  private
    FOnClick: TNotifyEvent;
    function GetButton: TTMSFNCButton;
  protected
    function SupportsRealControl: Boolean; override;
    function CreateControl: TTMSFNCDataGridCellControl; override;
    procedure InitializeControl; override;
    procedure DoButtonClick(Sender: TObject);
  public
    property OnClick: TNotifyEvent read FOnClick write FOnClick;
    property Button: TTMSFNCButton read GetButton;
  end;

  TTMSFNCDataGridProgressBarCellControlInfo = class(TTMSFNCDataGridCellControlInfo)
  private
    FValue: Integer;
  public
    function CopyInstance: TTMSFNCDataGridCellControlInfo; override;
    procedure Assign(Source: TTMSFNCDataGridCellControlInfo); override;
    constructor Create; override;
    function Compare(AInfo: TTMSFNCDataGridCellControlInfo): Boolean; override;
    property Value: Integer read FValue write FValue;
  end;

  TTMSFNCDataGridProgressBarCell = class(TTMSFNCDataGridCell)
  private
    FValue: Integer;
    function GetProgressBar: TProgressBar;
  protected
    function GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass; override;
    procedure RetrieveControlInfo(AInfo: TTMSFNCDataGridCellControlInfo); override;
    procedure ApplyControlProperties; override;
    procedure InitializeControl; override;
    function CreateControl: TTMSFNCDataGridCellControl; override;
  public
    property ProgressBar: TProgressBar read GetProgressBar;
    property Value: Integer read FValue write FValue;
  end;

  TTMSFNCDataGridDataProgressBarCell = class(TTMSFNCDataGridProgressBarCell);

  TTMSFNCDataGridBitmapCell = class(TTMSFNCDataGridCell)
  private
    FBitmap: TTMSFNCBitmap;
    FBitmapName: string;
    function GetBitmap: TTMSFNCBitmap;
    function GetBitmapAlign: TTMSFNCDataGridCellControlAlign;
    procedure SetBitmapAlign(const Value: TTMSFNCDataGridCellControlAlign);
  protected
    function IsControlAssigned: Boolean; override;
    function GetControlWidth: Single; override;
    function GetControlHeight: Single; override;
  public
    destructor Destroy; override;
    procedure DrawControl(AGraphics: TTMSFNCGraphics); override;
    property Bitmap: TTMSFNCBitmap read GetBitmap;
    property BitmapName: string read FBitmapName write FBitmapName;
    property BitmapAlign: TTMSFNCDataGridCellControlAlign read GetBitmapAlign write SetBitmapAlign;
  end;

  TTMSFNCDataGridFilterEditorCell = class(TTMSFNCDataGridCell)
  protected
    function SupportsRealControl: Boolean; override;
  end;

  TTMSFNCDataGridCellClass = class of TTMSFNCDataGridCell;

  TTMSFNCDataGridCellHelper = class helper for TTMSFNCDataGridCell
  private
    function GetIsNodeCell: Boolean;
    function GetAsNodeCell: TTMSFNCDataGridNodeCell;
    function GetAsBitmapCell: TTMSFNCDataGridBitmapCell;
    function GetAsButtonCell: TTMSFNCDataGridButtonCell;
    function GetAsCheckBoxCell: TTMSFNCDataGridCheckBoxCell;
    function GetAsFNCButtonCell: TTMSFNCDataGridFNCButtonCell;
    function GetAsProgressBarCell: TTMSFNCDataGridProgressBarCell;
    function GetAsRadioButtonCell: TTMSFNCDataGridRadioButtonCell;
    function GetIsBitmapCell: Boolean;
    function GetIsButtonCell: Boolean;
    function GetIsCheckBoxCell: Boolean;
    function GetIsFNCButtonCell: Boolean;
    function GetIsProgressBarCell: Boolean;
    function GetIsRadioButtonCell: Boolean;
  published
    property IsNodeCell: Boolean read GetIsNodeCell;
    property AsNodeCell: TTMSFNCDataGridNodeCell read GetAsNodeCell;
    property IsBitmapCell: Boolean read GetIsBitmapCell;
    property AsBitmapCell: TTMSFNCDataGridBitmapCell read GetAsBitmapCell;
    property IsProgressBarCell: Boolean read GetIsProgressBarCell;
    property AsProgressBarCell: TTMSFNCDataGridProgressBarCell read GetAsProgressBarCell;
    property IsCheckBoxCell: Boolean read GetIsCheckBoxCell;
    property AsCheckBoxCell: TTMSFNCDataGridCheckBoxCell read GetAsCheckBoxCell;
    property IsFNCButtonCell: Boolean read GetIsFNCButtonCell;
    property AsFNCButtonCell: TTMSFNCDataGridFNCButtonCell read GetAsFNCButtonCell;
    property IsButtonCell: Boolean read GetIsButtonCell;
    property AsButtonCell: TTMSFNCDataGridButtonCell read GetAsButtonCell;
    property IsRadioButtonCell: Boolean read GetIsRadioButtonCell;
    property AsRadioButtonCell: TTMSFNCDataGridRadioButtonCell read GetAsRadioButtonCell;
  end;

function DefaultMergeInfo: TTMSFNCDataGridCellMergeInfo;
function CreateMergeInfo(AColumnOffset, ARowOffset, AColumnSpan, ARowSpan: Integer): TTMSFNCDataGridCellMergeInfo;
function DefaultMouseInfo: TTMSFNCDataGridMouseInfo;
function DefaultKeyInfo: TTMSFNCDataGridKeyInfo;
function IsExtendedCell(ACell: TTMSFNCDataGridCellItem): Boolean;
function AsExtendedCell(ACell: TTMSFNCDataGridCellItem): TTMSFNCDataGridCellItemExtended;

implementation

uses
  Math, WEBLib.TMSFNCDataGridData, WEBLib.TMSFNCDataGridRenderer, WEBLib.TMSFNCUtils, WEBLib.Forms;

{$IFDEF WEBLIB}
const
  TTMSFNCDATAGRIDRADIOBUTTONCHECKED =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+Cjxzdmcgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMjQgM'+
  'jQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Zz4KICAgICAgICA8cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgICAgICAgPHBhdGggZD0iTTEyIDIyQzYuNDc3IDIyIDIgMTcuNTIzIDIgMTJTNi40NzcgMiAxMiAyczEwIDQuNDc3IDEwIDEwLTQuNDc3IDEwLTEwIDEwem0wLTJhOCA4'+
  'IDAgMSAwIDAtMTYgOCA4IDAgMCAwIDAgMTZ6bTAtM2E1IDUgMCAxIDEgMC0xMCA1IDUgMCAwIDEgMCAxMHoiLz4KICAgIDwvZz4KPC9zdmc+';
  TTMSFNCDATAGRIDRADIOBUTTONUNCHECKED =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPgo8c3ZnIHdpZHRoPSI4MDBweCIgaGVpZ2h0PSI4MDBweCIgdmlld0JveD0iMCAwIDI0IDI0I'+
  'iBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMkMxNy41MjI4IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcxNSAxNy41MjI4IDIgMTIgMkM2LjQ3NzE1IDIgMiA2LjQ3NzE1IDIgMTJDMiAxNy41'+
  'MjI4IDYuNDc3MTUgMjIgMTIgMjJaTTEyIDIwQzE2LjQxODMgMjAgMjAgMTYuNDE4MyAyMCAxMkMyMCA3LjU4MTcyIDE2LjQxODMgNCAxMiA0QzcuNTgxNzIgNCA0IDcuNTgxNzIgNCAxMkM0IDE2LjQxODMgNy41ODE3MiAyMCAxMiAyMFoiIGZpbGw9IiMwMDAwMDAiLz4NCjwvc3ZnPg';
  TTMSFNCDATAGRIDCHECKBOXCHECKED =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZ'+
  'y8xOTk5L3hsaW5rIj4KICAgIDwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+CiAgICA8dGl0bGU+aWNfZmx1ZW50X2NoZWNrYm94X2NoZWNrZWRfMjRfcmVndWxhcjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVz'+
  'Yz4KICAgIDxnIGlkPSLwn5SNLVByb2R1Y3QtSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJpY19mbHVlbnRfY2hlY2tib3hfY2hlY2tlZF8yNF9yZWd1bGFyIiBmaWxsPSIjMjEyMTIxIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICA'+
  'gICAgICAgICA8cGF0aCBkPSJNMTguMjUsMyBDMTkuNzY4NzgzMSwzIDIxLDQuMjMxMjE2OTQgMjEsNS43NSBMMjEsMTguMjUgQzIxLDE5Ljc2ODc4MzEgMTkuNzY4NzgzMSwyMSAxOC4yNSwyMSBMNS43NSwyMSBDNC4yMzEyMTY5NCwyMSAzLDE5Ljc2ODc4MzEgMywxOC4yNSBMMyw1Ljc1IEMzLDQuMjMxMjE2OTQgNC4yMzEyMTY5NCwzID'+
  'UuNzUsMyBMMTguMjUsMyBaIE0xOC4yNSw0LjUgTDUuNzUsNC41IEM1LjA1OTY0NDA2LDQuNSA0LjUsNS4wNTk2NDQwNiA0LjUsNS43NSBMNC41LDE4LjI1IEM0LjUsMTguOTQwMzU1OSA1LjA1OTY0NDA2LDE5LjUgNS43NSwxOS41IEwxOC4yNSwxOS41IEMxOC45NDAzNTU5LDE5LjUgMTkuNSwxOC45NDAzNTU5IDE5LjUsMTguMjUgTDE5L'+
  'jUsNS43NSBDMTkuNSw1LjA1OTY0NDA2IDE4Ljk0MDM1NTksNC41IDE4LjI1LDQuNSBaIE0xMCwxNC40MzkzMzk4IEwxNi40Njk2Njk5LDcuOTY5NjY5OTEgQzE2Ljc2MjU2MzEsNy42NzY3NzY3IDE3LjIzNzQzNjksNy42NzY3NzY3IDE3LjUzMDMzMDEsNy45Njk2Njk5MSBDMTcuNzk2NTk2Niw4LjIzNTkzNjQ4IDE3LjgyMDgwMjcsOC42'+
  'NTI2MDAxNiAxNy42MDI5NDgyLDguOTQ2MjExNjUgTDE3LjUzMDMzMDEsOS4wMzAzMzAwOSBMMTAuNTMwMzMwMSwxNi4wMzAzMzAxIEMxMC4yNjQwNjM1LDE2LjI5NjU5NjYgOS44NDczOTk4NCwxNi4zMjA4MDI3IDkuNTUzNzg4MzUsMTYuMTAyOTQ4MiBMOS40Njk2Njk5MSwxNi4wMzAzMzAxIEw2LjQ2OTY2OTkxLDEzLjAzMDMzMDEgQzY'+
  'uMTc2Nzc2NywxMi43Mzc0MzY5IDYuMTc2Nzc2NywxMi4yNjI1NjMxIDYuNDY5NjY5OTEsMTEuOTY5NjY5OSBDNi43MzU5MzY0OCwxMS43MDM0MDM0IDcuMTUyNjAwMTYsMTEuNjc5MTk3MyA3LjQ0NjIxMTY1LDExLjg5NzA1MTggTDcuNTMwMzMwMDksMTEuOTY5NjY5OSBMMTAsMTQuNDM5MzM5OCBMMTYuNDY5NjY5OSw3Ljk2OTY2OTkxIE'+
  'wxMCwxNC40MzkzMzk4IFoiIGlkPSLwn46oQ29sb3IiPgoNPC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+';
  TTMSFNCDATAGRIDCHECKBOXUNCHECKED =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZ'+
  'y8xOTk5L3hsaW5rIj4KICAgIDwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+CiAgICA8dGl0bGU+aWNfZmx1ZW50X2NoZWNrYm94X3VuY2hlY2tlZF8yNF9yZWd1bGFyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9k'+
  'ZXNjPgogICAgPGcgaWQ9IvCflI0tUHJvZHVjdC1JY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImljX2ZsdWVudF9jaGVja2JveF91bmNoZWNrZWRfMjRfcmVndWxhciIgZmlsbD0iIzIxMjEyMSIgZmlsbC1ydWxlPSJub256ZXJvIj4'+
  'KICAgICAgICAgICAgPHBhdGggZD0iTTUuNzUsMyBMMTguMjUsMyBDMTkuNzY4NzgzMSwzIDIxLDQuMjMxMjE2OTQgMjEsNS43NSBMMjEsMTguMjUgQzIxLDE5Ljc2ODc4MzEgMTkuNzY4NzgzMSwyMSAxOC4yNSwyMSBMNS43NSwyMSBDNC4yMzEyMTY5NCwyMSAzLDE5Ljc2ODc4MzEgMywxOC4yNSBMMyw1Ljc1IEMzLDQuMjMxMjE2OTQgNC'+
  '4yMzEyMTY5NCwzIDUuNzUsMyBaIE01Ljc1LDQuNSBDNS4wNTk2NDQwNiw0LjUgNC41LDUuMDU5NjQ0MDYgNC41LDUuNzUgTDQuNSwxOC4yNSBDNC41LDE4Ljk0MDM1NTkgNS4wNTk2NDQwNiwxOS41IDUuNzUsMTkuNSBMMTguMjUsMTkuNSBDMTguOTQwMzU1OSwxOS41IDE5LjUsMTguOTQwMzU1OSAxOS41LDE4LjI1IEwxOS41LDUuNzUgQ'+
  'zE5LjUsNS4wNTk2NDQwNiAxOC45NDAzNTU5LDQuNSAxOC4yNSw0LjUgTDUuNzUsNC41IFoiIGlkPSLwn46oQ29sb3IiPgoNPC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+';
{$ENDIF}

type
  TTMSFNCDataGridCellControlOpen = class(TTMSFNCDataGridCellControl);
  TTMSFNCDataGridRendererOpen = class(TTMSFNCDataGridRenderer);
  TTMSFNCDataGridDataOpen = class(TTMSFNCDataGridData);
  TTMSFNCDataGridCellParentOpen = class(TTMSFNCDataGridCellParent);
  TCustomFormOpen = class(TCustomForm);
  {$IFDEF FMXLIB}
  TStyledControlOpen = class(TStyledControl);
  {$ENDIF}

function DefaultMouseInfo: TTMSFNCDataGridMouseInfo;
begin
  Result.Button := TMouseButton.mbLeft;
  Result.X := -1;
  Result.Y := -1;
  Result.Shift := [];
  Result.Cursor := crDefault;
  Result.Kind := gmkNone;
  Result.WheelDelta := 0;
  Result.Blocked := False;
  Result.Handled := False;
end;

function DefaultKeyInfo: TTMSFNCDataGridKeyInfo;
begin
  Result.Key := 0;
  Result.KeyChar := #0;
  Result.Shift := [];
  Result.Kind := gkkNone;
  Result.Blocked := False;
  Result.Handled := False;
end;

function CreateMergeInfo(AColumnOffset, ARowOffset, AColumnSpan, ARowSpan: Integer): TTMSFNCDataGridCellMergeInfo;
begin
  Result.ColumnOffset := AColumnOffset;
  Result.RowOffset := ARowOffset;
  Result.ColumnSpan := AColumnSpan;
  Result.RowSpan := ARowSpan;
end;

function DefaultMergeInfo: TTMSFNCDataGridCellMergeInfo;
begin
  Result := CreateMergeInfo(-1, -1, 0, 0);
end;

function IsExtendedCell(ACell: TTMSFNCDataGridCellItem): Boolean;
begin
  Result := ACell is TTMSFNCDataGridCellItemExtended;
end;

function AsExtendedCell(ACell: TTMSFNCDataGridCellItem): TTMSFNCDataGridCellItemExtended;
begin
  Result := ACell as TTMSFNCDataGridCellItemExtended;
end;

{$IFDEF FMXWEBLIB}
function TTMSFNCDataGridCellControlWrapper.EnterChildren(AObject: IControl): Boolean;
begin
  Result := inherited EnterChildren(AObject);
  if Assigned(OnEnter) then
    OnEnter(Self);
end;

function TTMSFNCDataGridCellControlWrapper.ExitChildren(AObject: IControl): Boolean;
begin
  Result := inherited ExitChildren(AObject);
  if Assigned(OnExit) then
    OnExit(Self);
end;
{$ENDIF}

{$IFDEF VCLLIB}
procedure TTMSFNCDataGridCellControlWrapper.Paint;
begin
  inherited;
  Canvas.Brush.Color := Color;
  Canvas.FillRect(Rect(0, 0, Width, Height));
end;
{$ENDIF}

{$IFDEF WEBLIB}
function TTMSFNCDataGridCellControlWrapper.CreateElement: TJSElement;
begin
  Result := document.createElement('SPAN')
end;
{$ENDIF}

procedure TTMSFNCDataGridCell.AfterExport;
begin
  FIsExporting := False;
end;

procedure TTMSFNCDataGridCell.ApplyControlColor;
begin
  {$IFDEF VCLLIB}
  if Assigned(Control) then
  begin
    TTMSFNCDataGridCellControlOpen(Control).Color := Layout.Fill.Color;
    if Assigned(FControlWrapper) then
      FControlWrapper.Color := Layout.Fill.Color;
  end;
  {$ENDIF}
end;

procedure TTMSFNCDataGridCell.ApplyControlProperties;
begin
  ApplyControlColor;
end;

procedure TTMSFNCDataGridCell.ApplyScale(AScale: Single);
begin
  FScale := AScale;

  if Layout.Font.Size > 0 then
    Layout.Font.Size := Round(Layout.Font.Size * FScale)
  else
    Layout.Font.Size := Round(12 * FScale);

  Layout.Stroke.Width := Layout.Stroke.Width * FScale;
end;

procedure TTMSFNCDataGridCell.BeforeExport;
begin
  FIsExporting := True;
end;

procedure TTMSFNCDataGridCell.ClearControlCache;
begin
  if Assigned(ControlCacheList) then
    ControlCacheList.RemoveItem(ControlInfo);
end;

constructor TTMSFNCDataGridCell.Create(ARect: TRectF; AColumn, ARow: Integer;
  AData: TTMSFNCDataGridCellItem; AKind: TTMSFNCDataGridCellKind; ARoot: TObject);
begin
  FRoot := ARoot;
  FScale := 1.0;
  FCalcRect := ARect;
  FRect := ARect;
  FColumn := AColumn;
  FRow := ARow;
  FData := AData;
  FKind := AKind;
  FControlAlign := gcaNone;
  FControlPosition := gcpCenterRight;
  FDrawElements := AllElements;
  FLayout := nil;
  FIsExporting := False;
  FSortIndicator := gsiNone;
  FFilterButton := False;
  FCommentIndicatorColor := gcOrange;
  FCommentIndicator := False;
  FControlActive := False;
  FControlCache := nil;

  FControlRef := CreateControl;
  InitializeControl;

  RegisterClass(TTMSFNCDataGridCellControlWrapper);
end;

function TTMSFNCDataGridCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := nil;
end;

function TTMSFNCDataGridCell.CreateControlCache: TTMSFNCBitmap;
var
  r: TRectF;
  rd: TTMSFNCDataGridRenderer;
  p: TTMSFNCDataGridCellParent;
  hp: Boolean;
  cf: TCustomForm;
  cr: TRectF;
  ci: TTMSFNCDataGridCellControlCache;
  cif: TTMSFNCDataGridCellControlInfo;
begin
  Result := nil;

  if Assigned(Control) and Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    r := GetControlRect(SupportsRealControl);
    rd := Root as TTMSFNCDataGridRenderer;
    p := rd.GetParentHost;
    if SupportsRealControl then
    begin
      if Assigned(p) and Assigned(ControlWrapper) then
      begin
        {$IFDEF WEBLIB}
        TTMSFNCDataGridCellParentOpen(p).IncUpdateCount;
        {$ENDIF}
        cr := RectF(Max(ClipRect.Left, r.Left), Max(ClipRect.Top, r.Top), Min(ClipRect.Right, r.Right), Min(ClipRect.Bottom, r.Bottom));
        ControlWrapper.SetBounds(Round(cr.Left), Round(cr.Top), Round(cr.Right - cr.Left), Round(cr.Bottom - cr.Top));
        Control.SetBounds(Round(r.Left - cr.Left), Round(r.Top - cr.Top), Round(r.Right - r.Left), Round(r.Bottom - r.Top));
        Control.Parent := ControlWrapper;
        ControlWrapper.Parent := p;
        ApplyControlProperties;
        {$IFDEF WEBLIB}
        TTMSFNCDataGridCellParentOpen(p).DecUpdateCount;
        {$ENDIF}
      end;
    end
    else
    begin
      FreeAndNil(FControlCache);

      if Assigned(p) then
      begin
        {$IFDEF WEBLIB}
        TTMSFNCDataGridCellParentOpen(p).IncUpdateCount;
        {$ENDIF}

        hp := Assigned(Control.Parent);

        if not hp then
        begin
          if p.Owner is TCustomform then
            cf := p.Owner as TCustomForm
          else
            cf := TTMSFNCUtils.GetOwnerForm(p.Owner);

          Control.SetBounds(-10000, -10000, Round(r.Right - r.Left), Round(r.Bottom - r.Top));

          if Assigned(cf) then
            Control.Parent := cf;
        end;

        if not hp then
        begin
          {$IFDEF FMXLIB}
          if Control is TStyledControl then
          begin
            TStyledControl(Control).NeedStyleLookup;
            TStyledControl(Control).ApplyStyleLookup;
          end;
          {$ENDIF}
          ApplyControlProperties;
        end;

        FControlCache := GetControlBitmap;

        cif := ControlInfo;
        ci := FControlCacheList.GetCacheItem(cif);
        if Assigned(ci) then
          ci.Bitmap.Assign(FControlCache)
        else
          FControlCacheList.Add(TTMSFNCDataGridCellControlCache.Create(cif, FControlCache));

        if not hp then
          Control.Parent := nil;

        Result := FControlCache;

        {$IFDEF WEBLIB}
        TTMSFNCDataGridCellParentOpen(p).DecUpdateCount;
        {$ENDIF}
      end;
    end;
  end;
end;

destructor TTMSFNCDataGridCell.Destroy;
var
  ct: TTMSFNCDataGridCellControl;
  {$IFDEF WEBLIB}
  p: TTMSFNCDataGridCellParent;
  {$ENDIF}
  rd: TTMSFNCDataGridRenderer;
  e: TTMSFNCDataGridCellControlWrapper;
begin
  e := nil;
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) and not Assigned(FControlRef) then
  begin
    rd := Root as TTMSFNCDataGridRenderer;
    TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.TryGetValue(Coordinate.ToString, e);
  end;

  if Assigned(Control) and not Assigned(e) then
  begin
    ct := Control;
    if Assigned(ct) and not (csDestroying in ct.ComponentState) and Assigned(ct.Parent) and (ct.Parent is TTMSFNCDataGridCellParent) then
    begin
      {$IFDEF WEBLIB}
      p := ct.Parent as TTMSFNCDataGridCellParent;
      TTMSFNCDataGridCellParentOpen(p).IncUpdateCount;
      {$ENDIF}
      ct.Parent := nil;
      {$IFDEF WEBLIB}
      TTMSFNCDataGridCellParentOpen(p).DecUpdateCount;
      {$ENDIF}
    end;
  end;

  FreeAndNil(FLayout);
  FreeAndNil(FControlCache);

  if not Assigned(e) then
    FreeAndNil(FControlWrapper)
  else
    FControlWrapper := nil;

  FreeAndNil(FControlInfo);
  FreeAndNil(FControlMargins);

  FData := nil;
  FBitmapContainer := nil;
  FOnCommentIndicatorClick := nil;
  FOnFilterButtonClick := nil;
  FFilterIcon := nil;
  FSortDescendingIcon := nil;
  FSortAscendingIcon := nil;

  FreeAndNil(FControlRef);
  inherited;
end;

procedure TTMSFNCDataGridCell.DoAfterDraw(AGraphics: TTMSFNCGraphics);
begin
  if Assigned(OnAfterDraw) then
    OnAfterDraw(Self, AGraphics);
end;

procedure TTMSFNCDataGridCell.DoBeforeDraw(AGraphics: TTMSFNCGraphics;
  var ACanDraw: Boolean);
begin
  if Assigned(OnBeforeDraw) then
    OnBeforeDraw(Self, AGraphics, ACanDraw);
end;

procedure TTMSFNCDataGridCell.DoCommentIndicatorClick;
begin
  if Assigned(OnCommentIndicatorClick) then
    OnCommentIndicatorClick(Self);
end;

procedure TTMSFNCDataGridCell.DoControlWrapperEnter(Sender: TObject);
var
  rd: TTMSFNCDataGridRenderer;
begin
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) and Assigned(FControlWrapper) then
  begin
    rd := Root as TTMSFNCDataGridRenderer;
    TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.Clear;
    TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.AddOrSetValue(Coordinate.ToString, FControlWrapper);
  end;
end;

procedure TTMSFNCDataGridCell.DoControlWrapperExit(Sender: TObject);
var
  rd: TTMSFNCDataGridRenderer;
begin
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) and Assigned(FControlWrapper) then
  begin
    rd := Root as TTMSFNCDataGridRenderer;
    TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.Remove(Coordinate.ToString);
  end;
end;

procedure TTMSFNCDataGridCell.DoFilterButtonClick;
begin
  if Assigned(OnFilterButtonClick) then
    OnFilterButtonClick(Self);
end;

procedure TTMSFNCDataGridCell.Draw(AGraphics: TTMSFNCGraphics);
var
  b: Boolean;
begin
  AGraphics.SetFill(Layout.Fill);
  AGraphics.SetStroke(Layout.Stroke);
  AGraphics.SetFont(Layout.Font);

  b := True;
  DoBeforeDraw(AGraphics, b);
  if b then
  begin
    DrawBackground(AGraphics);
    DrawContent(AGraphics);
    DoAfterDraw(AGraphics);
  end;
end;

procedure TTMSFNCDataGridCell.DrawBackground(AGraphics: TTMSFNCGraphics);
begin
  if (gcdFill in DrawElements) or (gcdStroke in DrawElements) then
  begin
    if not (gcdFill in DrawElements) then
      AGraphics.Fill.Kind := gfkNone;

    if not (gcdStroke in DrawElements) then
      AGraphics.Stroke.Kind := gskNone;

    AGraphics.DrawRectangle(FRect, Layout.Sides, gcrmNone);
  end;
end;

procedure TTMSFNCDataGridCell.DrawCommentIndicator(AGraphics: TTMSFNCGraphics);
var
  pth: TTMSFNCGraphicsPath;
  r: TRectF;
begin
  inherited;
  r := GetCommentIndicatorRect;
  AGraphics.Fill.Kind := gfkSolid;
  AGraphics.Fill.Color := CommentIndicatorColor;
  AGraphics.Stroke.Kind := gskNone;
  pth := TTMSFNCGraphicsPath.Create;
  try
    pth.MoveTo(PointF(r.Left, r.Top));
    pth.LineTo(PointF(r.Right, r.Top));
    pth.LineTo(PointF(r.Right, r.Bottom));
    pth.ClosePath;
    AGraphics.DrawPath(pth);
  finally
    pth.Free;
  end;
end;

procedure TTMSFNCDataGridCell.DrawContent(AGraphics: TTMSFNCGraphics);
begin
  if gcdText in DrawElements then
    DrawText(AGraphics);

  if gcdControl in DrawElements then
    DrawControl(AGraphics);

  if CommentIndicator and (gcdCommentIndicator in DrawElements) then
    DrawCommentIndicator(AGraphics);

  if (SortIndicator <> gsiNone) and (gcdSortIndicator in DrawElements) then
    DrawSortIndicator(AGraphics);

  if FilterButton and (gcdFilterButton in DrawElements) then
    DrawFilterButton(AGraphics);
end;

procedure TTMSFNCDataGridCell.DrawControl(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
  st: TTMSFNCGraphicsSaveState;
  b: TTMSFNCBitmap;
  ci: TTMSFNCDataGridCellControlCache;
  e: ITMSFNCGraphicsExport;
begin
  if Assigned(Control) then
  begin
    if IsExporting and Supports(Control, ITMSFNCGraphicsExport, e) then
    begin
      r := GetControlRect(True);
      st := AGraphics.SaveState;
      try
        AGraphics.ClipRect(Rect);
        e.ApplyExportScale(Scale);
        e.Export(AGraphics, r);
        e.ResetExportScale;
      finally
        AGraphics.RestoreState(st);
      end;
    end
    else
    begin
      if not SupportsRealControl then
        ApplyControlProperties;

      ci := FControlCacheList.GetCacheItem(ControlInfo);
      if Assigned(ci) then
        b := ci.Bitmap
      else
        b := FControlCache;

      if (not SupportsRealControl and not Assigned(b)) or SupportsRealControl then
        b := CreateControlCache;

      if not SupportsRealControl and Assigned(b) and not FControlActive then
      begin
        r := GetControlRect(True);
        st := AGraphics.SaveState;
        try
          AGraphics.ClipRect(Rect);
          AGraphics.DrawBitmap(r, b);
        finally
          AGraphics.RestoreState(st);
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridCell.DrawFilterButton(AGraphics: TTMSFNCGraphics);
var
  bmp: TTMSFNCBitmap;
  bmpr: TRectF;
begin
  inherited;

  bmpr := GetFilterButtonRect;
  bmp := FilterIcon;
  if Assigned(bmp) then
    AGraphics.DrawBitmap(bmpr, bmp);
end;

procedure TTMSFNCDataGridCell.DrawSortIndicator(AGraphics: TTMSFNCGraphics);
var
  bmp: TTMSFNCBitmap;
  bmpr: TRectF;
begin
  inherited;

  bmp := nil;
  case SortIndicator of
    gsiAscending: bmp := SortAscendingIcon;
    gsiDescending: bmp := SortDescendingIcon;
  end;

  bmpr := GetSortIndicatorRect;
  if Assigned(bmp) then
    AGraphics.DrawBitmap(bmpr, bmp);
end;

procedure TTMSFNCDataGridCell.DrawText(AGraphics: TTMSFNCGraphics);
var
  dr: TRectF;
  s: string;
  st: TTMSFNCGraphicsSaveState;
begin
  dr := GetTextRect;
  s := GetDisplayValue;
  if s <> '' then
  begin
    st := AGraphics.SaveState;
    try
      AGraphics.ClipRect(Rect);
      AGraphics.DrawText(dr, s, Layout.WordWrapping, Layout.TextAlign, Layout.VerticalTextAlign,
        gttNone, Layout.TextAngle{, -1, -1, not DisplayHTMLFormatting});
    finally
      AGraphics.RestoreState(st);
    end;
  end;
end;

function TTMSFNCDataGridCell.GetActualTextRect: TRectF;
var
  g: TTMSFNCGraphics;
  r, tr: TRectF;
  s: string;
begin
  Result := EmptyRect;
  r := GetTextRect;
  g := TTMSFNCGraphics.CreateBitmapCanvas;
  try
    g.Context.BeginScene;
    g.SetFont(Layout.Font);
    s := Text;
    if (s = '') then
      s := 'gh';

    tr := g.CalculateText(s, r, Layout.WordWrapping{, not DisplayHTMLFormatting});
    tr.Left := r.Left;
    tr.Right := r.Right;

    case Layout.TextAlign of
      gtaCenter:
      begin
        case Layout.VerticalTextAlign of
          gtaCenter: tr := RectF(r.Left + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2, r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2, r.Left  + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2 + (tr.Right - tr.Left), r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2 + (tr.Bottom - tr.Top));
          gtaLeading: tr := RectF(r.Left + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2, r.Top, r.Left + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2 + (tr.Right - tr.Left), r.Top + (tr.Bottom - tr.Top));
          gtaTrailing: tr := RectF(r.Left + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2, r.Bottom - (tr.Bottom - tr.Top), r.Left + ((r.Right - r.Left) - (tr.Right - tr.Left)) / 2 + (tr.Right - tr.Left), r.Bottom);
        end;
      end;
      gtaLeading:
      begin
        case Layout.VerticalTextAlign of
          gtaCenter: tr := RectF(r.Left, r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2, r.Left + (tr.Right - tr.Left), r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2 + (tr.Bottom - tr.Top));
          gtaLeading: tr := RectF(r.Left, r.Top, r.Left + (tr.Right - tr.Left), r.Top + (tr.Bottom - tr.Top));
          gtaTrailing: tr := RectF(r.Left, r.Bottom - (tr.Bottom - tr.Top), r.Left + (tr.Right - tr.Left), r.Bottom);
        end;
      end;
      gtaTrailing:
      begin
        case Layout.VerticalTextAlign of
          gtaCenter: tr := RectF(r.Right - (tr.Right - tr.Left), r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2, r.Right, r.Top + ((r.Bottom - r.Top) - (tr.Bottom - tr.Top)) / 2 + (tr.Bottom - tr.Top));
          gtaLeading: tr := RectF(r.Right - (tr.Right - tr.Left), r.Top, r.Right, r.Top + (tr.Bottom - tr.Top));
          gtaTrailing: tr := RectF(r.Right - (tr.Right - tr.Left), r.Bottom - (tr.Bottom - tr.Top), r.Right, r.Bottom);
        end;
      end;
    end;

    Result := tr;

    Result.Top := Max(r.Top, Result.Top);
    Result.Left := Max(r.Left, Result.Left);
    Result.Right := r.Right;
    Result.Bottom := r.Bottom;

    g.Context.EndScene;
  finally
    g.Free;
  end;
end;

function TTMSFNCDataGridCell.GetBottom: Single;
begin
  Result := Rect.Bottom;
end;

function TTMSFNCDataGridCell.GetCommentIndicatorRect: TRectF;
var
  sz: Single;
begin
  Result := RectF(0, 0, 0, 0);
  if CommentIndicator and (gcdCommentIndicator in DrawElements) then
  begin
    sz := GetCommentIndicatorSize;
    Result := RectF(Rect.Right - sz - 1, Rect.Top + 1, Rect.Right - 1, Rect.Top + sz + 1);
  end;
end;

function TTMSFNCDataGridCell.GetCommentIndicatorSize: Single;
begin
  Result := 12 * FScale;
end;

function TTMSFNCDataGridCell.GetControlWrapper: TTMSFNCDataGridCellControlWrapper;
var
  rd: TTMSFNCDataGridRenderer;
begin
  if not Assigned(FControlWrapper) and Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    rd := Root as TTMSFNCDataGridRenderer;
    TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.TryGetValue(Coordinate.ToString, FControlWrapper);
  end;

  if not Assigned(FControlWrapper) then
  begin
    FControlWrapper := TTMSFNCDataGridCellControlWrapper.Create(nil);
    {$IFDEF FMXLIB}
    FControlWrapper.Stored := False;
    FControlWrapper.ClipChildren := True;
    {$ENDIF}
    FControlWrapper.OnEnter := @DoControlWrapperEnter;
    FControlWrapper.OnExit := @DoControlWrapperExit;
  end;

  Result := FControlWrapper;
end;

function TTMSFNCDataGridCell.GetControl: TTMSFNCDataGridCellControl;
begin
  Result := nil;
  if Assigned(FControl) then
    Result := FControl
  else if Assigned(FControlRef) then
    Result := FControlRef;
end;

function TTMSFNCDataGridCell.GetControlBitmap: TTMSFNCBitmap;
begin
  {$IFDEF FMXLIB}
  TTMSFNCDataGridCellControlOpen(Control).DoMouseLeave;
  {$ENDIF}
  Result := TTMSFNCBitmap(Control.MakeScreenshot);
end;

function TTMSFNCDataGridCell.GetControlHeight: Single;
begin
  Result := 0;
  if Assigned(Control) then
    Result := Control.Height;
end;

function TTMSFNCDataGridCell.GetControlInfo: TTMSFNCDataGridCellControlInfo;
begin
  if not Assigned(FControlInfo) then
    FControlInfo := GetControlInfoClass.Create;

  Result := FControlInfo;
  RetrieveControlInfo(Result);
end;

function TTMSFNCDataGridCell.GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass;
begin
  Result := TTMSFNCDataGridCellControlInfo;
end;

function TTMSFNCDataGridCell.GetControlMargins: TTMSFNCMargins;
begin
  if not Assigned(FControlMargins) then
    FControlMargins := TTMSFNCMargins.Create;

  Result := FControlMargins;
end;

function TTMSFNCDataGridCell.GetControlRect(AApplySize: Boolean): TRectF;
var
  r: TRectF;
  cw, ch: Single;
begin
  Result := RectF(0, 0, 0, 0);
  if IsControlAssigned and (gcdControl in DrawElements) then
  begin
    r := GetSortIndicatorRect;
    r := RectF(Rect.Left, Rect.Top, r.Left, Rect.Bottom);
    if AApplySize then
      InflateRectEx(r, -2 * FScale, -2 * FScale)
    else
      InflateRectEx(r, -2, -2);

    cw := GetControlWidth;
    ch := GetControlHeight;

    if AApplySize then
    begin
      cw := Round(cw * FScale);
      ch := Round(ch * FScale);
    end;

    case ControlAlign of
      gcaNone:
      begin
        case ControlPosition of
          gcpTopLeft: Result := RectF(r.Left, r.Top, r.Left + cw, r.Top + ch);
          gcpTopCenter: Result := RectF(r.Left + ((r.Right - r.Left - cw) / 2), r.Top, r.Left + ((r.Right - r.Left - cw) / 2) + cw, r.Top + ch);
          gcpTopRight: Result := RectF(r.Right - cw, r.Top, r.Right, r.Top + ch);
          gcpCenterLeft: Result := RectF(r.Left, r.Top + ((r.Bottom - r.Top) - ch) / 2, r.Left + cw, r.Top + ((r.Bottom - r.Top) - ch) / 2 + ch);
          gcpCenterCenter: Result := RectF(r.Left + ((r.Right - r.Left - cw) / 2), r.Top + ((r.Bottom - r.Top) - ch) / 2, r.Left + ((r.Right - r.Left - cw) / 2) + cw, r.Top + ((r.Bottom - r.Top) - ch) / 2 + ch);
          gcpCenterRight: Result := RectF(r.Right - cw, r.Top + ((r.Bottom - r.Top) - ch) / 2, r.Right, r.Top + ((r.Bottom - r.Top) - ch) / 2 + ch);
          gcpBottomLeft: Result := RectF(r.Left, r.Bottom - ch, r.Left + cw, r.Bottom);
          gcpBottomCenter: Result := RectF(r.Left + ((r.Right - r.Left - cw) / 2), r.Bottom - ch, r.Left + ((r.Right - r.Left - cw) / 2) + cw, r.Bottom);
          gcpBottomRight: Result := RectF(r.Right - cw, r.Bottom - ch, r.Right, r.Bottom);
        end;
      end;
      gcaClient:
      begin
        Result := r;
        Result := RectF(Result.Left + ControlMargins.Left, Result.Top + ControlMargins.Top, Result.Right - ControlMargins.Right, Result.Bottom - ControlMargins.Bottom);
      end;
      gcaLeft:
      begin
        Result := RectF(r.Left, r.Top, r.Left + cw, r.Bottom);
        Result := RectF(Result.Left + ControlMargins.Left, Result.Top + ControlMargins.Top, Result.Right, Result.Bottom - ControlMargins.Bottom);
      end;
      gcaTop:
      begin
        Result := RectF(r.Left, r.Top, r.Right, r.Top + ch);
        Result := RectF(Result.Left + ControlMargins.Left, Result.Top + ControlMargins.Top, Result.Right - ControlMargins.Right, Result.Bottom);
      end;
      gcaRight:
      begin
        Result := RectF(r.Right - cw, r.Top, r.Right, r.Bottom);
        Result := RectF(Result.Left, Result.Top + ControlMargins.Top, Result.Right - ControlMargins.Right, Result.Bottom - ControlMargins.Bottom);
      end;
      gcaBottom:
      begin
        Result := RectF(r.Left, r.Bottom - ch, r.Right, r.Bottom);
        Result := RectF(Result.Left + ControlMargins.Left, Result.Top, Result.Right - ControlMargins.Right, Result.Bottom - ControlMargins.Bottom);
      end;
    end;

    Result := RectF(Floor(Result.Left), Floor(Result.Top), Floor(Result.Right), Floor(Result.Bottom));
  end;
end;

function TTMSFNCDataGridCell.GetControlWidth: Single;
begin
  Result := 0;
  if Assigned(Control) then
    Result := Control.Width;
end;

function TTMSFNCDataGridCell.GetCoordinate: TTMSFNCDataGridCellCoord;
begin
  Result := MakeCell(Column, Row);
end;

function TTMSFNCDataGridCell.GetDisplayValue: string;
var
  d: TTMSFNCDataGridCellItem;
begin
  Result := '';
  d := Data;
  if Assigned(d) then
    Result := d.DisplayValue;
end;

function TTMSFNCDataGridCell.GetDrawElements(
  AIsEditing: Boolean): TTMSFNCDataGridCellDrawElements;
begin
  if IsExporting then
    Result := ExportElements
  else
  begin
    if AIsEditing then
      Result := EditingElements
    else
      Result := AllElements;
  end;
end;

function TTMSFNCDataGridCell.GetFilterButtonRect: TRectF;
var
  sz: Single;
begin
  if FilterButton and (gcdFilterButton in DrawElements) then
  begin
    sz := GetFilterButtonSize;
    Result := RectF(Rect.Right - sz - (4 * FScale), Rect.Top + (Rect.Bottom - Rect.Top) / 2 - sz / 2, Rect.Right - (2 * FScale), Rect.Top + (Rect.Bottom - Rect.Top) / 2 + sz / 2);
  end
  else
    Result := RectF(Rect.Right, Rect.Top, Rect.Right, Rect.Bottom);
end;

function TTMSFNCDataGridCell.GetFilterButtonSize: Single;
begin
  Result := 16 * FScale;
end;

function TTMSFNCDataGridCell.GetHeight: Single;
begin
  Result := Rect.Bottom - Rect.Top;
end;

function TTMSFNCDataGridCell.GetLayout: TTMSFNCDataGridCellLayout;
begin
  if not Assigned(FLayout) then
    FLayout := TTMSFNCDataGridCellLayout.Create;

  Result := FLayout;
end;

function TTMSFNCDataGridCell.GetLeft: Single;
begin
  Result := Rect.Left;
end;

function TTMSFNCDataGridCell.GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF;
var
  cw, ch, sz, o: Single;
begin
  Result := GetTextSize(AGraphics);

  o := 4 * FScale;

  if (GetDisplayValue <> '') and (gcdText in DrawElements) then
  begin
    Result.cx := Result.cx + o;
    Result.cy := Result.cy + o;
  end;

  if (SortIndicator <> gsiNone) and (gcdSortIndicator in DrawElements) then
  begin
    sz := GetSortIndicatorSize;
    Result.cx := Result.cx + sz + o;
    Result.cy := Max(Result.cy, sz + o);
  end;

  if FilterButton and (gcdFilterButton in DrawElements) then
  begin
    sz := GetFilterButtonSize;
    Result.cx := Result.cx + sz + o;
    Result.cy := Max(Result.cy, sz + o);
  end;

  if IsControlAssigned and (gcdControl in DrawElements) then
  begin
    cw := GetControlWidth * FScale;
    ch := GetControlHeight * FScale;

    case ControlAlign of
      gcaLeft, gcaRight: Result.cx := Result.cx + cw + o;
      gcaTop, gcaBottom: Result.cy := Result.cy + ch + o;
      gcaNone:
      begin
        Result.cx := Max(Result.cx, cw + o);

        case ControlPosition of
          gcpBottomLeft, gcpBottomCenter, gcpBottomRight, gcpTopLeft, gcpTopCenter, gcpTopRight: Result.cy := Result.cy + ch + o;
          gcpCenterLeft, gcpCenterCenter, gcpCenterRight: Result.cy := Max(Result.cy, ch + o);
        end;
      end;
    end;
  end;
end;

function TTMSFNCDataGridCell.GetRight: Single;
begin
  Result := Rect.Right;
end;

function TTMSFNCDataGridCell.GetScale: Single;
begin
  Result := FScale;
end;

function TTMSFNCDataGridCell.GetSortIndicatorRect: TRectF;
var
  sz: Single;
begin
  Result := GetFilterButtonRect;
  if (SortIndicator <> gsiNone) and (gcdSortIndicator in DrawElements) then
  begin
    sz := GetSortIndicatorSize;
    Result := RectF(Result.Left - sz -( 4 * FScale), Result.Top + (Result.Bottom - Result.Top) / 2 - sz / 2, Result.Left - (2 * FScale), Result.Top + (Result.Bottom - Result.Top) / 2 + sz / 2);
  end
  else
    Result := RectF(Result.Left, Result.Top, Result.Left, Result.Bottom);
end;

function TTMSFNCDataGridCell.GetSortIndicatorSize: Single;
begin
  Result := 16 * FScale;
end;

function TTMSFNCDataGridCell.GetText: string;
begin
  Result := GetDisplayValue;
end;

function TTMSFNCDataGridCell.GetTextRect: TRectF;
var
  r, rct, res: TRectF;
begin
  r := GetSortIndicatorRect;
  r := RectF(Rect.Left, Rect.Top, r.Left, Rect.Bottom);
  res := r;

  if IsControlAssigned and (gcdControl in DrawElements) then
  begin
    rct := GetControlRect(True);

    case ControlAlign of
      gcaTop: res := RectF(r.Left, rct.Bottom, r.Right, r.Bottom);
      gcaBottom: res := RectF(r.Left, r.Top, r.Right, rct.Top);
      gcaLeft: res := RectF(rct.Right, r.Top, r.Right, r.Bottom);
      gcaRight: res := RectF(r.Left, r.Top, rct.Left, r.Bottom);
      gcaNone:
      begin
        case ControlPosition of
          gcpTopLeft, gcpTopCenter, gcpTopRight: res := RectF(r.Left, rct.Bottom, r.Right, r.Bottom);
          gcpCenterLeft: res := RectF(rct.Right, r.Top, r.Right, r.Bottom);
          gcpCenterRight: res := RectF(r.Left, r.Top, rct.Left, r.Bottom);
          gcpBottomLeft, gcpBottomCenter, gcpBottomRight: res := RectF(r.Left, r.Top, r.Right, rct.Top);
        end;
      end;
    end;
  end;

  InflateRectEx(res, -3 * FScale, -3 * FScale);

  Result := res;
end;

function TTMSFNCDataGridCell.GetTextSize(AGraphics: TTMSFNCGraphics = nil): TSizeF;
var
  str: String;
  g: TTMSFNCGraphics;
  r, txtr: TRectF;
  w, h, c, s: Double;
  cw, ch: Double;
begin
  str := GetDisplayValue;
  Result.cx := 0;
  Result.cy := 0;

  if (str <> '') and (gcdText in DrawElements) then
  begin
    if not Assigned(AGraphics) then
    begin
      g := TTMSFNCGraphics.CreateBitmapCanvas;
      g.BeginScene;
    end
    else
      g := AGraphics;

    try
      g.BitmapContainer := BitmapContainer;
      g.SetFont(Layout.Font);
      r := GetTextRect;
      txtr := g.CalculateText(str, r, Layout.WordWrapping);

      Result.cx := txtr.Right - txtr.Left;
      Result.cy := txtr.Bottom - txtr.Top;

      if Layout.TextAngle <> 0 then
      begin
        w := Result.cx;
        h := Result.cy;
        c := Cos(DegToRad(Layout.TextAngle));
        s := Sin(DegToRad(Layout.TextAngle));

        cw := (Abs(w * c) + Abs(h * s));
        ch := (Abs(w * s) + Abs(h * c));

        Result.cx := cw;
        Result.cy := ch;
      end;

    finally
      if not Assigned(AGraphics) then
      begin
        g.EndScene;
        g.Free;
      end;
    end;
  end;
end;

function TTMSFNCDataGridCell.GetTop: Single;
begin
  Result := Rect.Top;
end;

function TTMSFNCDataGridCell.GetWidth: Single;
begin
  Result := Rect.Right - Rect.Left;
end;

procedure TTMSFNCDataGridCell.HandleKey(var AKeyInfo: TTMSFNCDataGridKeyInfo);
begin

end;

procedure TTMSFNCDataGridCell.HandleMouse(
  var AMouseInfo: TTMSFNCDataGridMouseInfo);
var
  c: TTMSFNCDataGridCellControl;
  cw: TTMSFNCDataGridCellControlWrapper;
  r, cr: TRectF;
  rd: TTMSFNCDataGridRenderer;
  p: TTMSFNCDataGridCellParent;
begin
  inherited;

  if not AMouseInfo.Blocked then
  begin
    case AMouseInfo.Kind of
      gmkDown:
      begin
        FDownOnFilterButton := PtInRectEx(GetFilterButtonRect, PointF(AMouseInfo.X, AMouseInfo.Y));
        AMouseInfo.Blocked := FDownOnFilterButton;
        if not AMouseInfo.Blocked then
        begin
          FDownOnComment := PtInRectEx(GetCommentIndicatorRect, PointF(AMouseInfo.X, AMouseInfo.Y));
          AMouseInfo.Blocked := FDownOnComment;
        end;
      end;
      gmkMove:
      begin
        AMouseInfo.Blocked := FDownOnFilterButton or FDownOnComment;
        if Assigned(Control) and not AMouseInfo.Blocked then
        begin
          if not SupportsRealControl then
          begin
            c := Control;
            case AMouseInfo.Kind of
              gmkMove:
              begin
                if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
                begin
                  rd := Root as TTMSFNCDataGridRenderer;
                  r := GetControlRect(True);
                  if PtInRectEx(r, PointF(AMouseInfo.X, AMouseInfo.Y)) and not FControlActive then
                  begin
                    AMouseInfo.Blocked := True;
                    p := rd.GetParentHost;
                    if Assigned(p) then
                    begin
                      cw := ControlWrapper;
                      cr := RectF(Max(ClipRect.Left, r.Left), Max(ClipRect.Top, r.Top), Min(ClipRect.Right, r.Right), Min(ClipRect.Bottom, r.Bottom));
                      cw.SetBounds(Round(cr.Left), Round(cr.Top), Round(cr.Right - cr.Left), Round(cr.Bottom - cr.Top));
                      c.SetBounds(Round(r.Left - cr.Left), Round(r.Top - cr.Top), Round(r.Right - r.Left), Round(r.Bottom - r.Top));
                      ApplyControlColor;
                      c.Parent := cw;
                      cw.Parent := p;
                      FControlActive := True;
                      rd.Display;
                    end;
                  end
                  else if FControlActive then
                  begin
                    c.Parent := nil;
                    cw := ControlWrapper;
                    cw.Parent := nil;
                    ApplyControlColor;
                    FControlActive := False;
                    FreeAndNil(FControlCache);
                    rd.Display;
                  end;
                end;
              end;
            end;
          end;
        end
        else
        begin
          if PtInRectEx(GetCommentIndicatorRect, PointF(AMouseInfo.X, AMouseInfo.Y)) then
          begin
            AMouseInfo.Blocked := True;
            AMouseInfo.Cursor := crHandPoint;
          end;
        end;
      end;
      gmkUp:
      begin
        AMouseInfo.Blocked := FDownOnFilterButton or FDownOnComment;
        if FDownOnFilterButton then
        begin
          FDownOnFilterButton := False;
          DoFilterButtonClick;
        end;

        if FDownOnComment then
        begin
          FDownOnComment := False;
          DoCommentIndicatorClick;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridCell.InitializeControl;
begin

end;

function TTMSFNCDataGridCell.IsControlAssigned: Boolean;
begin
  Result := Assigned(Control);
end;

function TTMSFNCDataGridCell.IsHTML: Boolean;
begin
//  if DisplayHTMLFormatting then
//    Result := False
//  else
    Result := (Pos('</', Text) > 0) or (Pos('/>', Text)  > 0) or (Pos('<BR>', UpperCase(Text)) > 0);
end;

procedure TTMSFNCDataGridCell.RetrieveControlInfo(
  AInfo: TTMSFNCDataGridCellControlInfo);
var
  AContext: TRttiContext;
  rt: TRttiType;
  prop: TRttiProperty;
  propv: TValue;
  r: TRectF;
begin
  if Assigned(Control) and Assigned(AInfo) then
  begin
    r := GetControlRect(SupportsRealControl);
    AInfo.&Type := Control.ClassType;
    AInfo.Width := r.Right - r.Left;
    AInfo.Height := r.Bottom - r.Top;
    AInfo.Tag := Control.Tag;
    {$IFDEF FMXLIB}
    AInfo.Focused := Control.IsFocused;
    {$ELSE}
    AInfo.Focused := TTMSFNCDataGridCellControlOpen(Control).Focused;
    {$ENDIF}

    AContext := TRttiContext.Create;
    try
      rt := AContext.GetType(Control.ClassInfo);
      prop := rt.GetProperty('Text');
      if Assigned(Prop) and Prop.IsReadable then
      begin
        propv := prop.GetValue(Control);
        AInfo.Text := propv.AsString;
      end;

      prop := rt.GetProperty('Caption');
      if Assigned(Prop) and Prop.IsReadable then
      begin
        propv := prop.GetValue(Control);
        AInfo.Caption := propv.AsString;
      end;
    finally
      AContext.Free;
    end;
  end;
end;

procedure TTMSFNCDataGridCell.SetControlMargins(const Value: TTMSFNCMargins);
begin
  if Assigned(FControlMargins) then
    FControlMargins.Assign(Value);
end;

function TTMSFNCDataGridCell.SupportsRealControl: Boolean;
{$IFNDEF FMXWEBLIB}
var
  rd: TTMSFNCDataGridRenderer;
{$ENDIF}
begin
  if IsExporting then
    Result := False
  else
  begin
    {$IFDEF FMXWEBLIB}
    Result := True;
    {$ELSE}
    Result := False;
    if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
    begin
      rd := Root as TTMSFNCDataGridRenderer;
      Result := TTMSFNCDataGridRendererOpen(rd).ControlWrapperList.ContainsKey(Coordinate.ToString);
    end;
    {$ENDIF}
  end;
end;

procedure TTMSFNCDataGridCell.UpdateData(AData: TTMSFNCDataGridCellItem);
begin
  FData := AData;
end;

function TTMSFNCDataGridCell.XYToAnchor(X, Y: Single): string;
var
  g: TTMSFNCGraphics;
  ha, va: TTMSFNCGraphicsTextAlign;
begin
  Result := '';
  if IsHTML then
  begin
    g := TTMSFNCGraphics.CreateBitmapCanvas;
    g.BeginScene;
//    g.OptimizedHTMLDrawing := OptimizedHTMLDrawing;
    g.BitmapContainer := BitmapContainer;
    try
      g.Font.Assign(Layout.Font);
      ha := Layout.TextAlign;
      va := Layout.VerticalTextAlign;
      Result := g.DrawText(GetTextRect, Text, False, ha, va, gttNone, 0, -1, -1, True, True, X, Y);
    finally
      g.EndScene;
      g.Free;
    end;
  end;

end;

{ TTMSFNCDataGridCellLayout }

procedure TTMSFNCDataGridCellLayout.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridCellLayout then
  begin
    FFill.Assign((Source as TTMSFNCDataGridCellLayout).Fill);
    FStroke.Assign((Source as TTMSFNCDataGridCellLayout).Stroke);
    FFont.Assign((Source as TTMSFNCDataGridCellLayout).Font);
    FTextAlign := (Source as TTMSFNCDataGridCellLayout).TextAlign;
    FVerticalTextAlign := (Source as TTMSFNCDataGridCellLayout).VerticalTextAlign;
    FWordWrapping := (Source as TTMSFNCDataGridCellLayout).WordWrapping;
    FTextAngle := (Source as TTMSFNCDataGridCellLayout).TextAngle;
    FSides := (Source as TTMSFNCDataGridCellLayout).Sides;
  end;
end;

procedure TTMSFNCDataGridCellLayout.Changed;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

constructor TTMSFNCDataGridCellLayout.Create(ADefaultFillColor: TTMSFNCGraphicsColor = gcWhite);
begin
  FTextAngle := 0;

  FFill := TTMSFNCGraphicsFill.Create(gfkSolid, ADefaultFillColor);
  FFill.OnChanged := @FillChanged;

  FStroke := TTMSFNCGraphicsStroke.Create;
  FStroke.Kind := gskSolid;
  FStroke.Color := gcSilver;
  FStroke.OnChanged := @StrokeChanged;

  FFont := TTMSFNCGraphicsFont.Create;
  FFont.OnChanged := @FontChanged;
  FTextAlign := gtaLeading;
  FVerticalTextAlign := gtaCenter;
  FWordWrapping := False;

  FSides := [gsLeft, gsTop, gsRight, gsBottom];
end;

destructor TTMSFNCDataGridCellLayout.Destroy;
begin
  FFont.Free;
  FFill.Free;
  FStroke.Free;
  inherited;
end;

procedure TTMSFNCDataGridCellLayout.FillChanged(Sender: TObject);
begin
  Changed;
end;

procedure TTMSFNCDataGridCellLayout.FontChanged(Sender: TObject);
begin
  Changed;
end;

function TTMSFNCDataGridCellLayout.IsTextAngleStored: Boolean;
begin
  Result := TextAngle <> 0;
end;

procedure TTMSFNCDataGridCellLayout.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  if FFill <> Value then
  begin
    FFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetFont(const Value: TTMSFNCGraphicsFont);
begin
  if FFont <> Value then
  begin
    FFont.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetSides(const Value: TTMSFNCGraphicsSides);
begin
  if FSides <> Value then
  begin
    FSides := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  if FStroke <> Value then
  begin
    FStroke.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetTextAlign(const Value: TTMSFNCGraphicsTextAlign);
begin
  if FTextAlign <> Value then
  begin
    FTextAlign := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetTextAngle(const Value: Double);
begin
  if FTextAngle <> Value then
  begin
    FTextAngle := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetVerticalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
begin
  if FVerticalTextAlign <> Value then
  begin
    FVerticalTextAlign := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.SetWordWrapping(const Value: Boolean);
begin
  if FWordWrapping <> Value then
  begin
    FWordWrapping := Value;
    Changed;
  end;
end;

procedure TTMSFNCDataGridCellLayout.StrokeChanged(Sender: TObject);
begin
  Changed;
end;

{ TTMSFNCDataGridNodeCell }

constructor TTMSFNCDataGridNodeCell.Create(ARect: TRectF; AColumn,
  ARow: Integer; AData: TTMSFNCDataGridCellItem; AKind: TTMSFNCDataGridCellKind;
  ARoot: TObject);
begin
  inherited;
  FIconSize := 16;
  FState := grnsExpanded;
  FIconPosition := gcipCenter;
end;

destructor TTMSFNCDataGridNodeCell.Destroy;
begin
  FCollapseIcon := nil;
  FExpandIcon := nil;
  FOnCollapse := nil;
  FOnExpand := nil;
  inherited;
end;

procedure TTMSFNCDataGridNodeCell.DoCollapse;
begin
  if Assigned(OnCollapse) then
    OnCollapse(Self);
end;

procedure TTMSFNCDataGridNodeCell.DoExpand;
begin
  if Assigned(OnExpand) then
    OnExpand(Self);
end;

procedure TTMSFNCDataGridNodeCell.DrawContent(AGraphics: TTMSFNCGraphics);
var
  bmp: TTMSFNCBitmap;
  bmpr: TRectF;
begin
  inherited;
  if gcdNodeIcon in DrawElements then
  begin
    bmp := nil;
    case State of
      grnsCollapsed: bmp := ExpandIcon;
      grnsExpanded: bmp := CollapseIcon;
    end;

    if Assigned(bmp) then
    begin
      bmpr := GetNodeRect;
      AGraphics.DrawBitmap(bmpr, bmp);
    end;
  end;
end;

function TTMSFNCDataGridNodeCell.GetNodeRect: TRectF;
var
  sz: Single;
begin
  Result := EmptyRect;
  if gcdNodeIcon in DrawElements then
  begin
    sz := GetNodeSize;

    case IconPosition of
      gcipTop: Result := RectF(Rect.Left + (5 * FScale), Rect.Top + (5 * FScale), Rect.Left + (5 * FScale) + sz, Rect.Top + (5 * FScale) + sz);
      gcipCenter: Result := RectF(Rect.Left + (5 * FScale), Rect.Top + (Rect.Bottom - Rect.Top - sz) / 2, Rect.Left + (5 * FScale) + sz, Rect.Top + (Rect.Bottom - Rect.Top - sz) / 2 + sz);
      gcipBottom: Result := RectF(Rect.Left + (5 * FScale), Rect.Bottom - (5 * FScale) - sz, Rect.Left + (5 * FScale) + sz, Rect.Bottom - (5 * FScale));
    end;
  end;
end;

function TTMSFNCDataGridNodeCell.GetNodeSize: Single;
begin
  Result := FIconSize * FScale;
end;

function TTMSFNCDataGridNodeCell.GetRequiredSize(AGraphics: TTMSFNCGraphics = nil): TSizeF;
begin
  Result := inherited GetRequiredSize(AGraphics);
  if gcdNodeIcon in DrawElements then
    Result.cx := Result.cx + GetNodeSize + (10 * FScale);
end;

function TTMSFNCDataGridNodeCell.GetTextRect: TRectF;
begin
  Result := inherited GetTextRect;
  if gcdNodeIcon in DrawElements then
    Result.Left := Result.Left + GetNodeSize + (10 * FScale);
end;

procedure TTMSFNCDataGridNodeCell.HandleMouse(
  var AMouseInfo: TTMSFNCDataGridMouseInfo);
begin
  inherited;

  if not AMouseInfo.Blocked then
  begin
    case AMouseInfo.Kind of
      gmkDown:
      begin
        FDownOnNode := PtInRectEx(GetNodeRect, PointF(AMouseInfo.X, AMouseInfo.Y));
        AMouseInfo.Blocked := FDownOnNode;
      end;
      gmkMove: AMouseInfo.Blocked := FDownOnNode;
      gmkUp:
      begin
        AMouseInfo.Blocked := FDownOnNode;
        if FDownOnNode then
        begin
          FDownOnNode := False;
          case State of
            grnsCollapsed: DoExpand;
            grnsExpanded: DoCollapse;
          end;
        end;
      end;
    end;
  end;
end;

{ TTMSFNCDataGridCellItem }

procedure TTMSFNCDataGridCellItem.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridCellItem then
  begin
    FValue := (Source as TTMSFNCDataGridCellItem).Value;
    FDisplayValue := (Source as TTMSFNCDataGridCellItem).DisplayValue;
    FInvalid := (Source as TTMSFNCDataGridCellItem).Invalid;
  end;
end;

constructor TTMSFNCDataGridCellItem.Create(AHost: TObject = nil);
begin
  FHost := AHost;
  FValue := nil;
  FDisplayValue := '';
  FInvalid := True;
end;

destructor TTMSFNCDataGridCellItem.Destroy;
begin
  FHost := nil;
  inherited;
end;

procedure TTMSFNCDataGridCellItem.SetValue(
  const V: TTMSFNCDataGridCellValue);
begin
  FValue := V;
  FInvalid := True;
end;

{ TTMSFNCDataGridCellItemExtended }

procedure TTMSFNCDataGridCellItemExtended.Assign(Source: TPersistent);
var
  o: TObject;
begin
  inherited;
  if Source is TTMSFNCDataGridCellItemExtended then
  begin
    FObject := (Source as TTMSFNCDataGridCellItemExtended).&Object;
    FIntegerValue := (Source as TTMSFNCDataGridCellItemExtended).IntegerValue;
    FBooleanValue := (Source as TTMSFNCDataGridCellItemExtended).BooleanValue;
    FControl := (Source as TTMSFNCDataGridCellItemExtended).Control;
    FControlAlign := (Source as TTMSFNCDataGridCellItemExtended).ControlAlign;
    FControlPosition := (Source as TTMSFNCDataGridCellItemExtended).ControlPosition;
    FControlText := (Source as TTMSFNCDataGridCellItemExtended).ControlText;
    FControlWidth := (Source as TTMSFNCDataGridCellItemExtended).ControlWidth;
    FControlHeight := (Source as TTMSFNCDataGridCellItemExtended).ControlHeight;
    if Assigned((Source as TTMSFNCDataGridCellItemExtended).Layout) then
    begin
      FreeAndNil(FLayout);
      FLayout := TTMSFNCDataGridCellLayout.Create;
      FLayout.Assign((Source as TTMSFNCDataGridCellItemExtended).Layout);
    end;

    if Assigned((Source as TTMSFNCDataGridCellItemExtended).FilterEditor) then
    begin
      FreeAndNil(FFilterEditor);
      FFilterEditor := (Source as TTMSFNCDataGridCellItemExtended).FilterEditor;
      (Source as TTMSFNCDataGridCellItemExtended).FilterEditor := nil;
    end;

    if Assigned((Source as TTMSFNCDataGridCellItemExtended).Renderer) then
    begin
      o := (Source as TTMSFNCDataGridCellItemExtended).Renderer;
      if o is TTMSFNCDataGridRenderer then
      begin
        FreeAndNil(FRenderer);
        FRenderer := TTMSFNCDataGridRenderer.Create(FHost);
        (FRenderer as TTMSFNCDataGridRenderer).Assign(o as TTMSFNCDataGridRenderer);
      end;
    end;

    FMergeInfo := (Source as TTMSFNCDataGridCellItemExtended).MergeInfo;
    FReadOnly := (Source as TTMSFNCDataGridCellItemExtended).ReadOnly;
    FType := (Source as TTMSFNCDataGridCellItemExtended).&Type;
    FComment := (Source as TTMSFNCDataGridCellItemExtended).Comment;
    if Assigned((Source as TTMSFNCDataGridCellItemExtended).FBitmap) then
      Bitmap.Assign((Source as TTMSFNCDataGridCellItemExtended).FBitmap);
    FBitmapName := (Source as TTMSFNCDataGridCellItemExtended).BitmapName;
    FRadioGroupIndex := (Source as TTMSFNCDataGridCellItemExtended).RadioGroupIndex;
    if Assigned((Source as TTMSFNCDataGridCellItemExtended).FControlMargins) then
      ControlMargins.Assign((Source as TTMSFNCDataGridCellItemExtended).FControlMargins);
  end;
end;

constructor TTMSFNCDataGridCellItemExtended.Create(AHost: TObject = nil);
begin
  inherited;
  FControl := nil;
  FObject := nil;
  FReadOnly := False;
  FType := gcitNormal;
  FBitmap := nil;
  FControlMargins := nil;
  FBitmapName := '';
  FControlAlign := gcaNone;
  FControlPosition := gcpCenterRight;
  FControlText := '';
  FControlWidth := -1;
  FControlHeight := -1;
  FComment := '';
  FRadioGroupIndex := 0;
  FMergeInfo := DefaultMergeInfo;
end;

destructor TTMSFNCDataGridCellItemExtended.Destroy;
begin
  FControl := nil;
  FObject := nil;
  FreeAndNil(FControlMargins);
  FreeAndNil(FBitmap);
  FreeAndNil(FManagedObject);
  DestroyRenderer;
  DestroyLayout;
  DestroyFilterEditor;

  inherited;
end;

procedure TTMSFNCDataGridCellItemExtended.DestroyFilterEditor;
begin
  FreeAndNil(FFilterEditor);
end;

procedure TTMSFNCDataGridCellItemExtended.DestroyRenderer;
begin
  FreeAndNil(FRenderer);
end;

procedure TTMSFNCDataGridCellItemExtended.DestroyLayout;
begin
  FreeAndNil(FLayout);
end;

function TTMSFNCDataGridCellItemExtended.HasMergeInfo: Boolean;
begin
  Result := (MergeInfo.ColumnOffset > -1) and (MergeInfo.RowOffset > -1)
    and (MergeInfo.ColumnSpan > 0) and (MergeInfo.RowSpan > 0);
end;

procedure TTMSFNCDataGridCellItemExtended.SetColumnOffset(const Value: Integer);
var
  m: TTMSFNCDataGridCellMergeInfo;
begin
  m := MergeInfo;
  m.ColumnOffset := Value;
  MergeInfo := m;
end;

procedure TTMSFNCDataGridCellItemExtended.SetColumnSpan(const Value: Integer);
var
  m: TTMSFNCDataGridCellMergeInfo;
begin
  m := MergeInfo;
  m.ColumnSpan := Value;
  MergeInfo := m;
end;

procedure TTMSFNCDataGridCellItemExtended.SetRowOffset(const Value: Integer);
var
  m: TTMSFNCDataGridCellMergeInfo;
begin
  m := MergeInfo;
  m.RowOffset := Value;
  MergeInfo := m;
end;

procedure TTMSFNCDataGridCellItemExtended.SetRowSpan(const Value: Integer);
var
  m: TTMSFNCDataGridCellMergeInfo;
begin
  m := MergeInfo;
  m.RowSpan := Value;
  MergeInfo := m;
end;

function TTMSFNCDataGridCellItemExtended.GetBitmap: TTMSFNCBitmap;
begin
  if not Assigned(FBitmap) then
    FBitmap := TTMSFNCBitmap.Create;

  Result := FBitmap;
end;

function TTMSFNCDataGridCellItemExtended.GetColumnOffset: Integer;
begin
  Result := MergeInfo.ColumnOffset;
end;

function TTMSFNCDataGridCellItemExtended.GetColumnSpan: Integer;
begin
  Result := MergeInfo.ColumnSpan;
end;

function TTMSFNCDataGridCellItemExtended.GetControlMargins: TTMSFNCMargins;
begin
  if not Assigned(FControlMargins) then
    FControlMargins := TTMSFNCMargins.Create;

  Result := FControlMargins;
end;

function TTMSFNCDataGridCellItemExtended.GetRowOffset: Integer;
begin
  Result := MergeInfo.RowOffset;
end;

function TTMSFNCDataGridCellItemExtended.GetRowSpan: Integer;
begin
  Result := MergeInfo.RowSpan;
end;

{ TTMSFNCDataGridRowItem }

procedure TTMSFNCDataGridRowItem.Assign(Source: TTMSFNCDataGridRowItem; AHost: TObject);
var
  c, ci: TTMSFNCDataGridCellItem;
  k: Integer;
begin
  FType := (Source as TTMSFNCDataGridRowItem).&Type;
  FNodeChildCount := (Source as TTMSFNCDataGridRowItem).&NodeChildCount;
  FNodeLevel := (Source as TTMSFNCDataGridRowItem).&NodeLevel;
  FNodeState := (Source as TTMSFNCDataGridRowItem).&NodeState;
  Data.Clear;
  for k in Source.Data.Keys do
  begin
    c := Source.Data[k];
    if Assigned(c) then
    begin
      if c is TTMSFNCDataGridCellItemExtended then
        ci := TTMSFNCDataGridCellItemExtended.Create(AHost)
      else
        ci := TTMSFNCDataGridCellItem.Create(AHost);

      ci.Assign(c);
      Data.AddOrSetValue(k, ci);
    end;
  end;
end;

destructor TTMSFNCDataGridRowItem.Destroy;
begin
  FreeAndNil(FData);
  inherited;
end;

function TTMSFNCDataGridRowItem.GetData: TTMSFNCDataGridRows;
begin
  if not Assigned(FData) then
    FData := TTMSFNCDataGridRows.Create([doOwnsValues]);

  Result := FData;
end;

function TTMSFNCDataGridRowItem.HasData: Boolean;
begin
  Result := Assigned(FData);
end;

procedure TTMSFNCDataGridRowItem.Init;
begin
  FType := grtDefault;
  FNodeChildCount := 0;
  FNodeLevel := 0;
  FNodeState := grnsExpanded;
end;

{ TTMSFNCDataGridCheckBox }

{$IFDEF WEBLIB}
function TTMSFNCDataGridCheckBox.MakeScreenshot: TBitmap;
begin
  Result := TBitmap.Create;
  if Checked then
    Result.LoadFromResource(TTMSFNCDATAGRIDCHECKBOXCHECKED)
  else
    Result.LoadFromResource(TTMSFNCDATAGRIDCHECKBOXUNCHECKED);
end;

procedure TTMSFNCDataGridCheckBox.UpdateElementVisual;
var
  chk: TJSHTMLInputElement;
  btn: TJSElement;
begin
  inherited;

  if Assigned(Container) then
  begin
    chk := TJSHTMLInputElement(GetCheckElement);

    if not IsLinked then
    begin
      chk.style.setProperty('background', 'transparent');
      chk.style.setProperty('-webkit-appearance', 'none');
      chk.style.setProperty('-moz-appearance', 'none');
      chk.style.setProperty('margin', '0px');
      if Checked then
        chk.style.setProperty('content', 'url(''' + TTMSFNCDATAGRIDCHECKBOXCHECKED  + ''')')
      else
        chk.style.setProperty('content', 'url(''' + TTMSFNCDATAGRIDCHECKBOXUNCHECKED  + ''')')
    end;
  end;
end;
{$ENDIF}

{ TTMSFNCDataGridCheckBoxCell }

procedure TTMSFNCDataGridCheckBoxCell.ApplyControlProperties;
var
  cn: TNotifyEvent;
  c: TTMSFNCDataGridCheckBox;
begin
  inherited;
  c := CheckBox;
  if Assigned(c) and Assigned(Data) then
  begin
    {$IFDEF FMXLIB}
    cn := c.OnChange;
    c.OnChange := nil;
    c.IsChecked := Checked;
    c.OnChange := @cn;
    {$ELSE}
    cn := c.OnClick;
    c.OnClick := nil;
    c.Checked := Checked;
    c.OnClick := cn;
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridCheckBoxCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := TTMSFNCDataGridCheckBox.Create(nil);
end;

procedure TTMSFNCDataGridCheckBoxCell.DoCheckChange(Sender: TObject);
var
  rd: TTMSFNCDataGridRenderer;
  c: TTMSFNCDataGridCheckBox;
begin
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    c := CheckBox;
    if Assigned(c) then
    begin
      {$IFDEF FMXLIB}
      Checked := c.IsChecked;
      {$ELSE}
      Checked := c.Checked;
      {$ENDIF}
    end;

    if not SupportsRealControl then
    begin
      FreeAndNil(FControlCache);
      rd := Root as TTMSFNCDataGridRenderer;
      rd.Display;
      ApplyControlColor;
    end;

    if Assigned(OnChange) then
      OnChange(Self);
  end;
end;

function TTMSFNCDataGridCheckBoxCell.GetCheckBox: TTMSFNCDataGridCheckBox;
begin
  Result := nil;
  if Assigned(FControlRef) and (FControlRef is TTMSFNCDataGridCheckBox) then
    Result := FControlRef as TTMSFNCDataGridCheckBox;
end;

procedure TTMSFNCDataGridCheckBoxCell.HandleKey(
  var AKeyInfo: TTMSFNCDataGridKeyInfo);
var
  rd: TTMSFNCDataGridRenderer;
begin
  inherited;
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    case AKeyInfo.Kind of
      gkkUp:
      begin
        if AKeyInfo.Key = KEY_SPACE then
        begin
          Checked := not Checked;
          if not SupportsRealControl then
          begin
            FreeAndNil(FControlCache);
            rd := Root as TTMSFNCDataGridRenderer;
            rd.Display;
          end;

          if Assigned(OnChange) then
            OnChange(Self);
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCDataGridCheckBoxCell.InitializeControl;
var
  c: TTMSFNCDataGridCheckBox;
begin
  c := CheckBox;
  if Assigned(c) then
  begin
    {$IFDEF FMXLIB}
    c.CanFocus := False;
    c.Text := '';
    c.OnChange := @DoCheckChange;
    {$ELSE}
    c.Caption := '';
    c.OnClick := DoCheckChange;
    {$ENDIF}
    c.TabStop := False;
    c.Width := 17;
    c.Height := 17;
  end;
end;

{ TTMSFNCDataGridRadioButton }

{$IFDEF WEBLIB}
function TTMSFNCDataGridRadioButton.MakeScreenshot: TBitmap;
begin
  Result := TBitmap.Create;
  if Checked then
    Result.LoadFromResource(TTMSFNCDATAGRIDRADIOBUTTONCHECKED)
  else
    Result.LoadFromResource(TTMSFNCDATAGRIDRADIOBUTTONUNCHECKED);
end;

procedure TTMSFNCDataGridRadioButton.UpdateElementVisual;
var
  chk: TJSHTMLInputElement;
  btn: TJSElement;
begin
  inherited;

  if Assigned(Container) then
  begin
    chk := TJSHTMLInputElement(GetRadioElement);

    if not IsLinked then
    begin
      chk.style.setProperty('background', 'transparent');
      chk.style.setProperty('-webkit-appearance', 'none');
      chk.style.setProperty('-moz-appearance', 'none');
      chk.style.setProperty('margin', '0px');
      if Checked then
        chk.style.setProperty('content', 'url(''' + TTMSFNCDATAGRIDRADIOBUTTONCHECKED  + ''')')
      else
        chk.style.setProperty('content', 'url(''' + TTMSFNCDATAGRIDRADIOBUTTONUNCHECKED  + ''')')
    end;
  end;
end;
{$ENDIF}

{ TTMSFNCDataGridRadioButtonCell }

procedure TTMSFNCDataGridRadioButtonCell.ApplyControlProperties;
var
  c: TNotifyEvent;
  r: TTMSFNCDataGridRadioButton;
begin
  inherited;
  r := RadioButton;
  if Assigned(r) and Assigned(Data) then
  begin
    {$IFDEF FMXLIB}
    c := r.OnChange;
    r.OnChange := nil;
    r.IsChecked := Checked;
    r.OnChange := @c;
    r.GroupName := Coordinate.ToString;
    {$ELSE}
    c := r.OnClick;
    r.OnClick := nil;
    r.Checked := Checked;
    r.OnClick := c;
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridRadioButtonCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := TTMSFNCDataGridRadioButton.Create(nil);
end;

procedure TTMSFNCDataGridRadioButtonCell.InitializeControl;
var
  r: TTMSFNCDataGridRadioButton;
begin
  r := RadioButton;
  if Assigned(r) then
  begin
    {$IFDEF FMXLIB}
    r.CanFocus := False;
    r.Text := '';
    r.OnChange := @DoRadioChange;
    {$ELSE}
    r.Caption := '';
    r.OnClick := DoRadioChange;
    {$ENDIF}
    r.TabStop := False;
    r.Width := 17;
    r.Height := 17;
  end;
end;

procedure TTMSFNCDataGridRadioButtonCell.DoRadioChange(Sender: TObject);
var
  rd: TTMSFNCDataGridRenderer;
  r: TTMSFNCDataGridRadioButton;
begin
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    ApplyControlColor;
    r := RadioButton;
    if Assigned(r) then
    begin
      {$IFDEF FMXLIB}
      Checked := r.IsChecked;
      {$ELSE}
      Checked := r.Checked;
      {$ENDIF}
    end;

    if not SupportsRealControl then
    begin
      FreeAndNil(FControlCache);
      rd := Root as TTMSFNCDataGridRenderer;
      rd.Display;
      ApplyControlColor;
    end;

    if Assigned(OnChange) then
      OnChange(Self);
  end;
end;

function TTMSFNCDataGridRadioButtonCell.GetRadioButton: TTMSFNCDataGridRadioButton;
begin
  Result := nil;
  if Assigned(FControlRef) and (FControlRef is TTMSFNCDataGridRadioButton) then
   Result := (FControlRef as TTMSFNCDataGridRadioButton);
end;

procedure TTMSFNCDataGridRadioButtonCell.HandleKey(
  var AKeyInfo: TTMSFNCDataGridKeyInfo);
var
  rd: TTMSFNCDataGridRenderer;
begin
  inherited;
  if Assigned(Root) and (Root is TTMSFNCDataGridRenderer) then
  begin
    case AKeyInfo.Kind of
      gkkUp:
      begin
        if (AKeyInfo.Key = KEY_SPACE) and not Checked then
        begin
          Checked := True;
          if not SupportsRealControl then
          begin
            FreeAndNil(FControlCache);
            rd := Root as TTMSFNCDataGridRenderer;
            rd.Display;
          end;
          if Assigned(OnChange) then
            OnChange(Self);
        end;
      end;
    end;
  end;
end;

{ TTMSFNCDataGridProgressBarCell }

procedure TTMSFNCDataGridProgressBarCell.ApplyControlProperties;
var
  p: TProgressBar;
begin
  inherited;
  p := ProgressBar;
  if Assigned(p) and Assigned(Data) then
  begin
    {$IFDEF FMXLIB}
    p.Value := Value;
    {$ELSE}
    p.Position := Value;
    {$IFNDEF WEBLIB}
    p.StepBy(-1);
    p.StepBy(1);
    {$ENDIF}
    {$ENDIF}
  end;
end;

function TTMSFNCDataGridProgressBarCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := TProgressBar.Create(nil);
end;

procedure TTMSFNCDataGridProgressBarCell.InitializeControl;
var
  p: TProgressBar;
begin
  p := ProgressBar;
  if Assigned(p) then
  begin
    {$IFDEF FMXLIB}
    p.CanFocus := False;
    {$ENDIF}
    p.TabStop := False;
  end;
end;

function TTMSFNCDataGridProgressBarCell.GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass;
begin
  Result := TTMSFNCDataGridProgressBarCellControlInfo;
end;

procedure TTMSFNCDataGridProgressBarCell.RetrieveControlInfo(
  AInfo: TTMSFNCDataGridCellControlInfo);
begin
  inherited;
  if AInfo is TTMSFNCDataGridProgressBarCellControlInfo then
    (AInfo as TTMSFNCDataGridProgressBarCellControlInfo).Value := Value;
end;

function TTMSFNCDataGridProgressBarCell.GetProgressBar: TProgressBar;
begin
  Result := nil;
  if Assigned(FControlRef) and (FControlRef is TProgressBar) then
    Result := FControlRef as TProgressBar;
end;

{ TTMSFNCDataGridButtonCell }

function TTMSFNCDataGridButtonCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := TButton.Create(nil);
end;

procedure TTMSFNCDataGridButtonCell.InitializeControl;
var
  b: TButton;
begin
  b := Button;
  if Assigned(b) then
  begin
    {$IFDEF FMXLIB}
    b.CanFocus := False;
    {$ENDIF}
    b.TabStop := False;
    b.OnClick := DoButtonClick;
  end;
end;

procedure TTMSFNCDataGridButtonCell.DoButtonClick(Sender: TObject);
begin
  if Assigned(OnClick) then
    OnClick(Self);
end;

function TTMSFNCDataGridButtonCell.GetButton: TButton;
begin
  Result := nil;
  if Assigned(FControlRef) and (FControlRef is TButton) then
    Result := FControlRef as TButton;
end;

function TTMSFNCDataGridButtonCell.SupportsRealControl: Boolean;
begin
  if IsExporting then
    Result := False
  else
  begin
    {$IFNDEF WEBLIB}
    Result := False;
    {$ELSE}
    Result := True;
    {$ENDIF}
  end;
end;

{ TTMSFNCDataGridFNCButtonCell }

function TTMSFNCDataGridFNCButtonCell.CreateControl: TTMSFNCDataGridCellControl;
begin
  Result := TTMSFNCButton.Create(nil);
end;

procedure TTMSFNCDataGridFNCButtonCell.InitializeControl;
var
  b: TTMSFNCButton;
begin
  b := Button;
  if Assigned(b) then
  begin
    {$IFDEF FMXLIB}
    b.CanFocus := False;
    {$ENDIF}
    b.TabStop := False;
    b.OnClick := DoButtonClick;
  end;
end;

procedure TTMSFNCDataGridFNCButtonCell.DoButtonClick(Sender: TObject);
begin
  if Assigned(OnClick) then
    OnClick(Self);
end;

function TTMSFNCDataGridFNCButtonCell.GetButton: TTMSFNCButton;
begin
  Result := nil;
  if Assigned(FControlRef) and (FControlRef is TTMSFNCButton) then
    Result := FControlRef as TTMSFNCButton;
end;

function TTMSFNCDataGridFNCButtonCell.SupportsRealControl: Boolean;
begin
  if IsExporting then
    Result := False
  else
  begin
    {$IFNDEF WEBLIB}
    Result := False;
    {$ELSE}
    Result := True;
    {$ENDIF}
  end;
end;

{ TTMSFNCDataGridBitmapCell }

destructor TTMSFNCDataGridBitmapCell.Destroy;
begin
  FreeAndNil(FBitmap);
  inherited;
end;

procedure TTMSFNCDataGridBitmapCell.DrawControl(AGraphics: TTMSFNCGraphics);
var
  bmp: TTMSFNCBitmap;
begin
  bmp := nil;
  if Assigned(Bitmap) and not IsBitmapEmpty(Bitmap) then
    bmp := Bitmap
  else if Assigned(BitmapContainer) and (BitmapName <> '') then
    bmp := BitmapContainer.FindBitmap(BitmapName);

  if Assigned(bmp) then
    AGraphics.DrawBitmap(GetControlRect(True), bmp);
end;

function TTMSFNCDataGridBitmapCell.GetBitmap: TTMSFNCBitmap;
begin
  if not Assigned(FBitmap) then
    FBitmap := TTMSFNCBitmap.Create;

  Result := FBitmap;
end;

function TTMSFNCDataGridBitmapCell.GetBitmapAlign: TTMSFNCDataGridCellControlAlign;
begin
  Result := ControlAlign;
end;

function TTMSFNCDataGridBitmapCell.GetControlHeight: Single;
begin
  Result := 32;
end;

function TTMSFNCDataGridBitmapCell.GetControlWidth: Single;
begin
  Result := 32;
end;

function TTMSFNCDataGridBitmapCell.IsControlAssigned: Boolean;
begin
  Result := True;
end;

procedure TTMSFNCDataGridBitmapCell.SetBitmapAlign(
  const Value: TTMSFNCDataGridCellControlAlign);
begin
  ControlAlign := Value;
end;

{ TTMSFNCDataGridCellControlCache }

constructor TTMSFNCDataGridCellControlCache.Create(AInfo: TTMSFNCDataGridCellControlInfo; ABitmap: TTMSFNCBitmap);
begin
  FInfo := AInfo.CopyInstance;
  Bitmap.Assign(ABitmap);
end;

destructor TTMSFNCDataGridCellControlCache.Destroy;
begin
  FreeAndNil(FBitmap);
  FreeAndNil(FInfo);
  inherited;
end;

function TTMSFNCDataGridCellControlCache.GetBitmap: TTMSFNCBitmap;
begin
  if not Assigned(FBitmap) then
    FBitmap := TTMSFNCBitmap.Create;

  Result := FBitmap;
end;

{ TTMSFNCDataGridCellControlCacheList }

function TTMSFNCDataGridCellControlCacheList.GetCacheItem(AControlCacheInfo: TTMSFNCDataGridCellControlInfo): TTMSFNCDataGridCellControlCache;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to Count - 1 do
  begin
    if Assigned(Items[I].FInfo) and Items[I].FInfo.Compare(AControlCacheInfo) then
    begin
      Result := Items[I];
      Break;
    end;
  end;
end;

procedure TTMSFNCDataGridCellControlCacheList.RemoveItem(
  AControlCacheInfo: TTMSFNCDataGridCellControlInfo);
var
  I: Integer;
begin
  for I := Count - 1 downto 0 do
  begin
    if Assigned(Items[I].FInfo) and Items[I].FInfo.Compare(AControlCacheInfo) then
    begin
      Self.Delete(I);
      Break;
    end;
  end;
end;

{ TTMSFNCDataGridCellControlInfo }

procedure TTMSFNCDataGridCellControlInfo.Assign(
  Source: TTMSFNCDataGridCellControlInfo);
begin
  if Source is TTMSFNCDataGridCellControlInfo then
  begin
    FType := (Source as TTMSFNCDataGridCellControlInfo).&Type;
    FWidth := (Source as TTMSFNCDataGridCellControlInfo).Width;
    FHeight := (Source as TTMSFNCDataGridCellControlInfo).Height;
    FText := (Source as TTMSFNCDataGridCellControlInfo).Text;
    FCaption := (Source as TTMSFNCDataGridCellControlInfo).Caption;
    FFocused := (Source as TTMSFNCDataGridCellControlInfo).Focused;
    FTag := (Source as TTMSFNCDataGridCellControlInfo).Tag;
  end;
end;

function TTMSFNCDataGridCellControlInfo.Compare(
  AInfo: TTMSFNCDataGridCellControlInfo): Boolean;
begin
  Result := (FType = AInfo.&Type) and (FWidth = AInfo.Width) and (FHeight = AInfo.Height)
    and (FText = AInfo.Text) and (FCaption = AInfo.Caption) and (FFocused = AInfo.Focused) and (FTag = AInfo.Tag);
end;

function TTMSFNCDataGridCellControlInfo.CopyInstance: TTMSFNCDataGridCellControlInfo;
begin
  Result := TTMSFNCDataGridCellControlInfo.Create;
  Result.Assign(Self);
end;

constructor TTMSFNCDataGridCellControlInfo.Create;
begin
  FType := nil;
  FWidth := 0;
  FHeight := 0;
  FText := '';
  FCaption := '';
  FTag := 0;
end;

{ TTMSFNCDataGridCheckedCell }

function TTMSFNCDataGridCheckedCell.GetControlInfoClass: TTMSFNCDataGridCellControlInfoClass;
begin
  Result := TTMSFNCDataGridCheckedCellControlInfo;
end;

procedure TTMSFNCDataGridCheckedCell.RetrieveControlInfo(
  AInfo: TTMSFNCDataGridCellControlInfo);
begin
  inherited;
  if AInfo is TTMSFNCDataGridCheckedCellControlInfo then
    (AInfo as TTMSFNCDataGridCheckedCellControlInfo).Checked := Checked;
end;

function TTMSFNCDataGridCheckedCell.SupportsRealControl: Boolean;
begin
  Result := False;
end;

{ TTMSFNCDataGridCheckedCellControlInfo }

procedure TTMSFNCDataGridCheckedCellControlInfo.Assign(
  Source: TTMSFNCDataGridCellControlInfo);
begin
  inherited;
  if Source is TTMSFNCDataGridCheckedCellControlInfo then
    FChecked := (Source as TTMSFNCDataGridCheckedCellControlInfo).Checked;
end;

function TTMSFNCDataGridCheckedCellControlInfo.Compare(
  AInfo: TTMSFNCDataGridCellControlInfo): Boolean;
begin
  Result := inherited Compare(AInfo);
  if AInfo is TTMSFNCDataGridCheckedCellControlInfo then
    Result := Result and (Checked = (AInfo as TTMSFNCDataGridCheckedCellControlInfo).Checked);
end;

function TTMSFNCDataGridCheckedCellControlInfo.CopyInstance: TTMSFNCDataGridCellControlInfo;
begin
  Result := TTMSFNCDataGridCheckedCellControlInfo.Create;
  Result.Assign(Self);
end;

constructor TTMSFNCDataGridCheckedCellControlInfo.Create;
begin
  inherited;
  FChecked := False;
end;

{ TTMSFNCDataGridProgressBarCellControlInfo }

procedure TTMSFNCDataGridProgressBarCellControlInfo.Assign(
  Source: TTMSFNCDataGridCellControlInfo);
begin
  inherited;
  if Source is TTMSFNCDataGridProgressBarCellControlInfo then
    FValue := (Source as TTMSFNCDataGridProgressBarCellControlInfo).Value;
end;

function TTMSFNCDataGridProgressBarCellControlInfo.Compare(
  AInfo: TTMSFNCDataGridCellControlInfo): Boolean;
begin
  Result := inherited Compare(AInfo);
  if AInfo is TTMSFNCDataGridProgressBarCellControlInfo then
    Result := Result and (Value = (AInfo as TTMSFNCDataGridProgressBarCellControlInfo).Value);
end;

function TTMSFNCDataGridProgressBarCellControlInfo.CopyInstance: TTMSFNCDataGridCellControlInfo;
begin
  Result := TTMSFNCDataGridProgressBarCellControlInfo.Create;
  Result.Assign(Self);
end;

constructor TTMSFNCDataGridProgressBarCellControlInfo.Create;
begin
  inherited;
  FValue := 0;
end;

{ TTMSFNCDataGridCellHelper }

function TTMSFNCDataGridCellHelper.GetAsBitmapCell: TTMSFNCDataGridBitmapCell;
begin
  Result := Self as TTMSFNCDataGridBitmapCell;
end;

function TTMSFNCDataGridCellHelper.GetAsButtonCell: TTMSFNCDataGridButtonCell;
begin
  Result := Self as TTMSFNCDataGridButtonCell;
end;

function TTMSFNCDataGridCellHelper.GetAsCheckBoxCell: TTMSFNCDataGridCheckBoxCell;
begin
  Result := Self as TTMSFNCDataGridCheckBoxCell;
end;

function TTMSFNCDataGridCellHelper.GetAsFNCButtonCell: TTMSFNCDataGridFNCButtonCell;
begin
  Result := Self as TTMSFNCDataGridFNCButtonCell;
end;

function TTMSFNCDataGridCellHelper.GetAsNodeCell: TTMSFNCDataGridNodeCell;
begin
  Result := Self as TTMSFNCDataGridNodeCell;
end;

function TTMSFNCDataGridCellHelper.GetAsProgressBarCell: TTMSFNCDataGridProgressBarCell;
begin
  Result := Self as TTMSFNCDataGridProgressBarCell;
end;

function TTMSFNCDataGridCellHelper.GetAsRadioButtonCell: TTMSFNCDataGridRadioButtonCell;
begin
  Result := Self as TTMSFNCDataGridRadioButtonCell;
end;

function TTMSFNCDataGridCellHelper.GetIsBitmapCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridBitmapCell;
end;

function TTMSFNCDataGridCellHelper.GetIsButtonCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridButtonCell;
end;

function TTMSFNCDataGridCellHelper.GetIsCheckBoxCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridCheckBoxCell;
end;

function TTMSFNCDataGridCellHelper.GetIsFNCButtonCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridFNCButtonCell;
end;

function TTMSFNCDataGridCellHelper.GetIsNodeCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridNodeCell;
end;

function TTMSFNCDataGridCellHelper.GetIsProgressBarCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridProgressBarCell;
end;

function TTMSFNCDataGridCellHelper.GetIsRadioButtonCell: Boolean;
begin
  Result := Self is TTMSFNCDataGridRadioButtonCell;
end;

{ TTMSFNCDataGridFilterEditorCell }

function TTMSFNCDataGridFilterEditorCell.SupportsRealControl: Boolean;
begin
  Result := True;
end;

initialization
begin
  {$IFDEF WEBLIB}
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDRADIOBUTTONCHECKED);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDRADIOBUTTONUNCHECKED);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCHECKBOXCHECKED);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCDATAGRIDCHECKBOXUNCHECKED);
  {$ENDIF}
  if not Assigned(TTMSFNCDataGridCell.FControlCacheList) then
    TTMSFNCDataGridCell.FControlCacheList := TTMSFNCDataGridCellControlCacheList.Create;
end;

{$IFNDEF WEBLIB}
finalization
begin
  FreeAndNil(TTMSFNCDataGridCell.FControlCacheList);
end;
{$ENDIF}

end.

